<template>
	<div id="appraisals-index"
		 class="app-home ui-styles"
		 :class="theme">

		<template class="view_container">

			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>

			<div class="master_view">
				<side-nav-bar :filesOpen="filesOpen" :fileOpen="fileOpen" :fileId="appraisalfile.id"
							  :fileNumber="appraisalfile.number" :reportOpen="reportOpen"
							  :reportNumber="appraisalreport.number" :versionNumber="appraisalreport.version"
							  :realEstates="appraisalreport_realestates" :realEstateId="realestate.id"
							  :reportId="appraisalreport.id"></side-nav-bar>

				<div class="app-container">
					<bar>
					</bar>
					<h1>{{ $t('Edit_Real_Estate') }} <span v-if="realestate.property_type">
															<span v-if="currentLocale == 'ca'">{{ realestate.property_type.name_ca}}</span>
															<span v-else-if="currentLocale == 'en'">{{ realestate.property_type.name_en}}</span>
															<span v-else>{{ realestate.property_type.name_es}}</span>
														</span> {{$t('at')}} <span
							v-if="realestate.street_name">{{ realestate.street_name
						}}</span><span
							v-if="realestate.street_number">, {{ realestate.street_number }}</span><span
							v-if="realestate.floor">, {{ realestate.floor}}</span><span
							v-if="realestate.door"> {{ realestate.door }}</span> <span
							v-if="realestate.dirty">*</span></h1>
					<message
							v-if="realestate.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>
					<div class="datedata">
						<p class="small">{{ $t('Created') }}: {{ millis_to_time(realestate.date_created) }}</p>
						<p class="small">{{ $t('Last_modified') }}: {{ millis_to_time(realestate.date_modified) }}</p>
					</div>


					<vue-tabs v-model="tabName">
						<v-tab :title="identification_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Identificació i pre-taxació')">{{identification_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Identification and pre-appraisal')">{{identification_text}}
							</div>
							<div v-else slot="title"
								 @click.prevent="setCurrentTabTitle('Identificación y pre-tasación')">{{identification_text}}
							</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="section-container">
											<h3>{{ $t('Property_type') }}</h3>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Property_type') }}</label>
													<multiselect placeholder=""
																 :value="property_typeValue"
																 :options="property_typeOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="realestate.property_type"
																 @input="set_realestate_property_type"></multiselect>
												</div>
											</div>

											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Asset_type')
														}} (BdE)</label>
													<multiselect placeholder=""
																 :value="asset_typeValue"
																 :options="asset_typeOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="realestate.asset_type"
																 @input="set_realestate_asset_type"></multiselect>
												</div>
											</div>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Dwelling_type')
														}} (BdE)</label>
													<multiselect placeholder=""
																 :value="dwelling_typeValue"
																 :options="dwelling_typeOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																 :searchable="true"
																 v-model="realestate.dwelling_type"
																 @input="set_realestate_dwelling_type"></multiselect>
												</div>
											</div>
										</div>
										<div class="section-container">
											<h3>{{ $t('Address') }}</h3>
											<div class="field-container">
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Country') }}</label>
													<multiselect placeholder=""
																 :value="countryValue"
																 :options="countryOptions"
																 track-by="iso_3166_alpha2_code"
																 :label="'name_en'"
																 :searchable="true"
																 v-model="realestate.country"
																 @input="set_realestate_country_option"></multiselect>
												</div>
											</div>

											<div class="field-container">
												<div class="ms-container" v-if="realestate.country">
													<div v-if="realestate.country.name_en === 'Spain'">
														<label class="field__group__label">{{ $t('Province') }}</label>
														<multiselect placeholder=""
																	 :value="provinceValue"
																	 :options="spanishProvinceOptions"
																	 track-by="id"
																	 :label="'name_ine'"
																	 :searchable="true"
																	 v-model="realestate.province"
																	 @input="set_realestate_province_option"></multiselect>
													</div>

													<div v-else>
														<label class="field__group__label">{{ $t('Province') }}</label>
														<input class="field__group__input"
															   type="text"
															   spellcheck="false"
															   v-model="realestate.province"
															   @input="set_realestate_province">
													</div>
												</div>
											</div>
											<div class="field-container">
												<div class="ms-container" v-if="realestate.province">
													<div v-if="realestate.country.name_en === 'Spain'">
														<label class="field__group__label">{{ $t('Municipality')
															}}</label>
														<multiselect placeholder=""
																	 :value="municipalityValue"
																	 :options="object_to_array(realestate_municipalities)"
																	 track-by="id"
																	 :label="'name_ine'"
																	 :searchable="true"
																	 v-model="realestate.municipality"
																	 @input="set_realestate_municipality_option"></multiselect>
													</div>
													<div v-else>
														<label class="field__group__label">{{ $t('Municipality')
															}}</label>
														<input class="field__group__input"
															   type="text"
															   spellcheck="false"
															   v-model="realestate.municipality"
															   @input="set_realestate_municipality">
													</div>
												</div>
											</div>
											<div v-if="realestate.municipality">
												<div class="field-container">
													<div class="field__group">
														<label class="field__group__label">{{ $t('Street_name')
															}}</label>
														<input class="field__group__input"
															   type="text"
															   spellcheck="false"
															   v-model="realestate.street_name"
															   @input="set_realestate_street_name">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Street_number')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   step="1"
															   spellcheck="false"
															   v-model="realestate.street_number"
															   @input="set_realestate_street_number">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Floor_name')
															}}</label>
														<input class="field__group__input"
															   type="text"
															   spellcheck="false"
															   v-model="realestate.floor"
															   @input="set_realestate_floor">
													</div>
													<div class="field__group">
														<label class="field__group__label"
															   v-if="realestate.property_type.name_db === 'parking'">{{ $t('pkg_number')
															}}</label>
														<label class="field__group__label" v-else="">{{ $t('Door')
															}}</label>
														<input class="field__group__input"
															   type="text"
															   spellcheck="false"
															   v-model="realestate.door"
															   @input="set_realestate_door">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Staircase') }}</label>
														<input class="field__group__input"
															   type="text"
															   spellcheck="false"
															   v-model="realestate.staircase"
															   @input="set_realestate_staircase">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Block') }}</label>
														<input class="field__group__input"
															   type="text"
															   spellcheck="false"
															   v-model="realestate.block"
															   @input="set_realestate_block">
													</div>
													<div class="field__group">
														<label class="field__group__label">{{ $t('Height_situation')
															}}</label>
														<input class="field__group__input"
															   type="number"
															   spellcheck="false"
															   v-model="realestate.floor_number"
															   @input="set_realestate_floor_number">
													</div>
													<div class="ms-container">
														<label class="field__group__label">{{ $t('Floor_type') }}</label>
														<multiselect placeholder=""
																	 :value="floor_typeValue"
																	 :options="floor_typeOptions"
																	 track-by="id"
																	 :label="(currentLocale === 'ca')?'name_ca':(currentLocale === 'en')?'name_en':'name_es'"
																	 :searchable="true"
																	 v-model="realestate.floor_type"
																	 @input="set_realestate_floor_type"></multiselect>
													</div>

												</div>
												<div class="section-container">
													<div class="field-container">
														<div class="field__group">
															<span class="help"><i>{{ $t('Full_address')}}:</i>&emsp;{{ realestate.full_address}}</span>
														</div>
													</div>


												</div>
											</div>
										</div>
										<div class="section-container"
											 v-if="this.realestate.municipality && this.realestate.street_name && this.realestate.street_number">
											<h3>{{ $t('Geolocation') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<button
															class="quote-request__aux__button"
															@click.prevent="onGeolocate"
															@keyup.enter="onGeolocate">
										<span><icon name="globe" scale="1"
													color="rgb(0, 79, 146)"></icon>&emsp;{{ $t('Geolocate')
											}}</span>
													</button>
												</div>
												<div v-if="google_geocode_loading">
									<span style="color: rgb(0, 79, 146)"><icon name="spinner" scale="1"
																			   color="rgb(0, 79, 146)" spin></icon>&emsp;{{ $t('Loading')
										}}...</span>
												</div>

												<div class="field__group">
													<label class="field__group__label">{{ $t('Latitude') }}</label>
													<input class="field__group__input"
														   type="number"
														   step="any"
														   spellcheck="false"
														   v-model="realestate.lat"
														   @input="set_realestate_lat">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Longitude') }}</label>
													<input class="field__group__input"
														   type="number"
														   step="any"
														   spellcheck="false"
														   v-model="realestate.lng"
														   @input="set_realestate_lng">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Postal_code') }}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="realestate.postal_code"
														   @input="set_realestate_postal_code">
												</div>
												<div class="field__group">
													<label class="field__group__label">X EPSG:25831</label>
													<input class="field__group__input"
														   type="number"
														   step="any"
														   spellcheck="false"
														   v-model="realestate.epsg25831_x"
														   @input="set_realestate_epsg25831_x">
												</div>
												<div class="field__group">
													<label class="field__group__label">Y EPSG:25831</label>
													<input class="field__group__input"
														   type="number"
														   step="any"
														   spellcheck="false"
														   v-model="realestate.epsg25831_y"
														   @input="set_realestate_epsg25831_y">
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
									<span class="help"><i>Aquesta geolocalització es correspon a l'adreça:</i>&emsp;{{ realestate.google_formatted_address
										}}, ({{ realestate.geohash }})</span>
												</div>
											</div>
										</div>
										<div class="section-container"
											 v-if="this.realestate.epsg25831_x && this.realestate.epsg25831_y">
											<h3>{{ $t('Census_section') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<button
															class="quote-request__aux__button"
															@click.prevent="onRequestCensusSectionInfo"
															@keyup.enter="onRequestCensusSectionInfo">
										<span><icon name="globe" scale="1"
													color="rgb(0, 79, 146)"></icon>&emsp;{{ $t('Census_section')}}</span>
													</button>
												</div>

												<div v-if="icc_census_section_loading">
									<span style="color: rgb(0, 79, 146)"><icon name="spinner" scale="1"
																			   color="rgb(0, 79, 146)" spin></icon>&emsp;{{ $t('Loading')
										}}...</span>
												</div>

												<div class="field__group">
													<label class="field__group__label">{{ $t('Census_section_code')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="realestate.census_section_code"
														   @input="set_realestate_census_section_code">
												</div>

											</div>
										</div>
										<div class="section-container"
											 v-if="this.realestate.epsg25831_x && this.realestate.epsg25831_y">
											<h3>{{ $t('Cadastral_data') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<button
															class="quote-request__aux__button"
															@click.prevent="onRequestCadastralReferenceSuggestion"
															@keyup.enter="onRequestCadastralReferenceSuggestion">
										<span><icon name="globe" scale="1"
													color="rgb(0, 79, 146)"></icon>&emsp;{{ $t('Cadastral_reference')}}</span>
													</button>
												</div>
												<div v-if="cadaster_ref_loading">
									<span style="color: rgb(0, 79, 146)"><icon name="spinner" scale="1"
																			   color="rgb(0, 79, 146)" spin></icon>&emsp;{{ $t('Loading')
										}}...</span>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Cadastral_reference')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   maxlength="20"
														   spellcheck="false"
														   v-model="realestate.cadastral_reference"
														   @input="set_realestate_cadastral_reference">
												</div>

												<div v-if="realestate.cadastral_reference">
													<message
															v-if="realestate.cadastral_reference.length > 0 && realestate.cadastral_reference.length < 20"
															:text="cad_ref_error_text_01" icon_name="exclamation"
															icon_color="darkred"
															border_color="red" text_color="darkred">
													</message>
												</div>
											</div>
											<div class="field-container">
												<!--
												<div class="field__group">
													<button
															class="quote-request__aux__button"
															@click.prevent="onOpenCadastralList"
															@keyup.enter="onOpenCadastralList">
										<span><icon name="external-link" scale="1"
													color="rgb(0, 79, 146)"></icon>&emsp;{{ $t('Open')}}&nbsp;{{ $t('Cadastral_List')}}</span>
													</button>
												</div>
												-->
												<div class="field__group">
													<button
															class="quote-request__aux__button"
															@click.prevent="onOpenCadastralMap"
															@keyup.enter="onOpenCadastralMap">
										<span><icon name="external-link" scale="1"
													color="rgb(0, 79, 146)"></icon>&emsp;{{ $t('Open')}}&nbsp;{{ $t('Cadastral_Map')}}</span>
													</button>
												</div>
											</div>
											<div class="field-container">

											</div>
										</div>
										<div class="section-container"
											 v-if="this.realestate.lat && this.realestate.lng">
											<h3>{{ $t('Maps') }}</h3>
											<div v-if="google_map_01_loading">
											<span style="color: rgb(0, 79, 146)"><icon name="spinner" scale="1"
																					   color="rgb(0, 79, 146)"
																					   spin></icon>&emsp;{{ $t('Loading')
												}} Map 01...</span>
											</div>
											<div v-if="google_map_02_loading">
											<span style="color: rgb(0, 79, 146)"><icon name="spinner" scale="1"
																					   color="rgb(0, 79, 146)"
																					   spin></icon>&emsp;{{ $t('Loading')
												}} Map 02...</span>
											</div>
											<div v-if="google_map_03_loading">
											<span style="color: rgb(0, 79, 146)"><icon name="spinner" scale="1"
																					   color="rgb(0, 79, 146)"
																					   spin></icon>&emsp;{{ $t('Loading')
												}} Map 03...</span>
											</div>
											<!--
											<div>
												<div @click.prevent="onRefreshMaps"
													 style="width: fit-content; margin-right: auto">
													<icon-button icon="refresh" text="Refresh Maps"
																 icon_color="rgb(0, 79, 146)"
																 text_color="rgb(0, 79, 146)"
																 border_color="lightgray"></icon-button>
												</div>
											</div>
											-->
											<div class="field-container" style="justify-content: baseline!important;">
												<div v-if="realestate.map_google_01_url">

													<div style="background: transparent; padding: 2em; border: 1px solid lightgray; margin: 2em;  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04)">
														<div style="text-align: center; padding-bottom: 1em">
															<span>{{ $t('Map') }} 1/3</span>
														</div>
														<div><img :src="realestate.map_google_01_url" width="640px"
																  height="480px"></div>

														<div>
															<table style="width: 640px; text-align: center">
																<tr>
																	<td>
																		<table style="width: 240px; text-align: center; margin: 0 auto;">

																			<tr>
																				<td colspan="2">
																					<span class="small">center: {{ realestate.map_google_01_lat
																						}}, {{ realestate.map_google_01_lng
																						}}</span>
																				</td>

																			</tr>
																			<tr>
																				<td colspan="2"
																					style="text-align: center!important">
																					<div @click.prevent="onGoUpMapGoogle01"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-up"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																			<tr>
																				<td>
																					<div @click.prevent="onGoLeftMapGoogle01"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-left"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																				<td>
																					<div @click.prevent="onGoRightMapGoogle01"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-right"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																			<tr>
																				<td colspan="2"
																					style="text-align: center!important">
																					<div @click.prevent="onGoDownMapGoogle01"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-down"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>

																		</table>

																	</td>
																	<td>
																		<table style="width: 240px; text-align: center; margin: 0 auto;">

																			<tr>
																				<td colspan="2">
																					<span class="small">zoom: {{ realestate.map_google_01_zoom
																						}}</span>
																				</td>
																			</tr>
																			<tr>
																				<td>

																					<div @click.prevent="onDecreaseZoomMapGoogle01"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="minus"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																				<td>
																					<div @click.prevent="onIncreaseZoomMapGoogle01"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="plus" text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																		</table>
																	</td>
																</tr>
															</table>

														</div>


													</div>
													<div>

													</div>


												</div>
												<div v-if="realestate.map_google_02_url">

													<div style="background: transparent; padding: 2em; border: 1px solid lightgray; margin: 2em; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04)">
														<div style="text-align: center; padding-bottom: 1em">
															<span>{{ $t('Map') }} 2/3</span>
														</div>
														<div><img :src="realestate.map_google_02_url" width="640px"
																  height="480px"></div>

														<div>
															<table style="width: 640px; text-align: center">
																<tr>
																	<td>
																		<table style="width: 240px; text-align: center; margin: 0 auto;">

																			<tr>
																				<td colspan="2">
																					<span class="small">center: {{ realestate.map_google_02_lat
																						}}, {{ realestate.map_google_02_lng
																						}}</span>
																				</td>

																			</tr>
																			<tr>
																				<td colspan="2"
																					style="text-align: center!important">
																					<div @click.prevent="onGoUpMapGoogle02"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-up"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																			<tr>
																				<td>
																					<div @click.prevent="onGoLeftMapGoogle02"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-left"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																				<td>
																					<div @click.prevent="onGoRightMapGoogle02"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-right"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																			<tr>
																				<td colspan="2"
																					style="text-align: center!important">
																					<div @click.prevent="onGoDownMapGoogle02"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-down"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>

																		</table>

																	</td>
																	<td>
																		<table style="width: 240px; text-align: center; margin: 0 auto;">

																			<tr>
																				<td colspan="2">
																					<span class="small">zoom: {{ realestate.map_google_02_zoom
																						}}</span>
																				</td>
																			</tr>
																			<tr>
																				<td>

																					<div @click.prevent="onDecreaseZoomMapGoogle02"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="minus"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																				<td>
																					<div @click.prevent="onIncreaseZoomMapGoogle02"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="plus" text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																		</table>
																	</td>
																</tr>
															</table>

														</div>


													</div>
													<div>

													</div>


												</div>
												<div v-if="realestate.map_google_03_url">

													<div style="background: transparent; padding: 2em; border: 1px solid lightgray; margin: 2em; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04)">
														<div style="text-align: center; padding-bottom: 1em">
															<span>{{ $t('Map') }} 3/3</span>
														</div>
														<div><img :src="realestate.map_google_03_url" width="640px"
																  height="480px"></div>

														<div>
															<table style="width: 640px; text-align: center">
																<tr>
																	<td>
																		<table style="width: 240px; text-align: center; margin: 0 auto;">

																			<tr>
																				<td colspan="2">
																					<span class="small">center: {{ realestate.map_google_03_lat
																						}}, {{ realestate.map_google_03_lng
																						}}</span>
																				</td>

																			</tr>
																			<tr>
																				<td colspan="2"
																					style="text-align: center!important">
																					<div @click.prevent="onGoUpMapGoogle03"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-up"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																			<tr>
																				<td>
																					<div @click.prevent="onGoLeftMapGoogle03"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-left"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																				<td>
																					<div @click.prevent="onGoRightMapGoogle03"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-right"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																			<tr>
																				<td colspan="2"
																					style="text-align: center!important">
																					<div @click.prevent="onGoDownMapGoogle03"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="arrow-down"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>

																		</table>

																	</td>
																	<td>
																		<table style="width: 240px; text-align: center; margin: 0 auto;">

																			<tr>
																				<td colspan="2">
																					<span class="small">zoom: {{ realestate.map_google_03_zoom
																						}}</span>
																				</td>
																			</tr>
																			<tr>
																				<td>

																					<div @click.prevent="onDecreaseZoomMapGoogle03"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="minus"
																									 text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																				<td>
																					<div @click.prevent="onIncreaseZoomMapGoogle03"
																						 style="width: fit-content; margin: 0 auto;">
																						<icon-button icon="plus" text=""
																									 icon_color="rgb(0, 79, 146)"
																									 text_color="rgb(0, 79, 146)"
																									 border_color="lightgray"
																									 min_width="32px"
																									 max_width="32px"></icon-button>
																					</div>
																				</td>
																			</tr>
																		</table>
																	</td>
																</tr>
															</table>

														</div>


													</div>
													<div>

													</div>


												</div>
											</div>
										</div>
										<div class="section-container"
											 v-if="this.realestate.lat && this.realestate.lng">
											<h3>{{ $t('Area_prices') }}</h3>


											<div class="field-container">

												<template>
													<gmap-map
															:center="{lat:this.realestate.lat, lng:this.realestate.lng}"
															:zoom="16"
															style="width: 100vw; height: 40vw"
															:options="{styles: mapStyles, scrollwheel: false}"
													>

														<gmap-marker
																:key="index"
																v-for="(m, index) in this.realestate.area_ads_markers"
																:position="m.position"
																:clickable=true
																:draggable=false
																:opacity="m.opacity"
																:title="m.title"
																:label="m.label"
																:icon="m.icon"
																@click="openAdUrl(m.url)"
														></gmap-marker>
														<gmap-marker
																:key="9999"
																:position="{lat:this.realestate.lat, lng:this.realestate.lng}"
																:clickable=false
																:draggable=false
														></gmap-marker>


													</gmap-map>
												</template>


											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Area_average_unit_price')}}</label>
													<span> <strong>{{ realestate.area_average_price | formatNumber
														}} €/m²</strong></span>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Max_distance')}} (Km.)</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   min="0.1"
														   step="0.1"
														   max="60"
														   v-model="realestate.area_ads_query_distance"
														   @input="set_realestate_area_ads_query_distance">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Ads_date_range')}}</label>
													<span> <strong>{{ this.prices_startdate_readformat
														}} - {{ this.prices_limitdate_readformat }}</strong></span>
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<button
															class="quote-request__aux__button"
															@click.prevent="onCheckPrices"
															@keyup.enter="onCheckPrices">
										<span><icon name="globe" scale="1"
													color="rgb(0, 79, 146)"></icon>&emsp;{{ $t('Check_prices')
											}}</span>
													</button>
												</div>
												<div v-if="check_prices_loading">
									<span style="color: rgb(0, 79, 146)"><icon name="spinner" scale="1"
																			   color="rgb(0, 79, 146)" spin></icon>&emsp;{{ $t('Loading')
										}}...</span>
												</div>
											</div>
											<div class="field-container" v-if="this.realestate.area_ads_markers">
												<span>* Nota: La següent és una selecció automàtica dels anuncis més propers a l'immoble extistents a la base de dades de BARNA-TASA, S.A.</span>

											</div>
											<div class="field-container">
												<table>
													<tr>
														<th style="width: 60px; text-align: center;">#</th>
														<th style="width: 160px;  text-align: center;">{{ $t('Actions')
															}}
														</th>
														<th>{{ $t('Address') }}</th>
														<th style="width: 320px;">{{ $t('Offer_unit_price') }}</th>
													</tr>
													<tr v-for="(m, index) in this.realestate.area_ads_markers">
														<td>{{ index + 1 }}</td>
														<td>

															<table style="border: none">
																<tr>
																	<td style="border: none; padding: 0.1rem;"><a
																			@click="openAdUrl(m.url)"
																			style="cursor: pointer;"
																	>
																		<icon name="link" scale=".9"
																			  color="gray"></icon>
																	</a></td>

																	<td style="border: none; padding: 0.1rem;"><a
																			@click="discardAd(index)"
																			style="cursor: pointer;"
																	>
																		<icon name="times" scale=".9"
																			  color="gray"></icon>
																	</a></td>
																</tr>
															</table>


														</td>
														<td>{{ m.address }}</td>
														<td :style="backgroundStyle(m.step)">
															<strong>{{ m.unit_price | formatNumber }} €/m²</strong></td>

													</tr>
												</table>
											</div>
										</div>
										<div class="section-container"
											 v-if="this.realestate.lat && this.realestate.lng">
											<h3>{{ $t('Pre_appraisal') }}</h3>


											<div class="field-container">

												<div class="field__group">
													<label class="field__group__label">{{ $t('Area_average_unit_price')
														}} (€/m²)</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="realestate.area_average_price"
														   @input="set_realestate_area_average_price">
												</div>

												<div class="field__group">
													<label class="field__group__label">{{ $t('Area_average_price_coef')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   step="0.01"
														   v-model="realestate.area_average_price_coef"
														   @input="set_realestate_area_average_price_coef">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Adopted_area_average_price')
														}}</label>
													<!--
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="realestate.adopted_area_average_price"
														   @input="set_realestate_adopted_area_average_price">
														   -->
													<span><strong>{{ realestate.adopted_area_average_price | formatNumber
														}} €/m²</strong></span>
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Estimated_built_area')
														}} (m²)</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="realestate.estimated_built_area"
														   @input="set_realestate_estimated_built_area">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Pre_appraisal_value')
														}}</label>
													<!--
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="realestate.pre_appraisal_value"
														   @input="set_realestate_pre_appraisal_value">-->
													<span><strong>{{ realestate.pre_appraisal_value | formatNumber
														}} €</strong></span>
												</div>
												<div v-if="!this.realestate.estimated_built_area">
													<message
															text="Falta indicar la superfície estimada"
															icon_name="exclamation"
															icon_color="darkred"
															border_color="red" text_color="darkred">
													</message>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</v-tab>
						<v-tab :title="appraisal_cost_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Pressupost')">{{quote_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Quote')">{{quote_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Presupuesto')">{{quote_text}}
							</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="form-section">
											<h3>{{ $t('Travel_expenses') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Travel_one_way_hours')
														}} (h)</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="realestate.travel_one_way_hours"
														   @input="set_realestate_travel_one_way_hours">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Travel_both_ways_hours')
														}}</label>
													<!--
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="realestate.travel_both_ways_hours"
														   @input="set_realestate_travel_both_ways_hours">
														   -->
													<span>{{ realestate.travel_both_ways_hours }} h</span>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Travel_fees_per_hour')
														}} (€/h)</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="realestate.travel_fees_per_hour"
														   @input="set_realestate_travel_fees_per_hour">
												</div>

											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Car_fuel_expenses_one_way')
														}} (€)</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="realestate.car_fuel_expenses_one_way"
														   @input="set_realestate_car_fuel_expenses_one_way">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Car_fuel_expenses_both_ways')
														}}</label>
													<!--
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="realestate.car_fuel_expenses_both_ways"
														   @input="set_realestate_car_fuel_expenses_both_ways">
														   -->
													<span>{{ realestate.car_fuel_expenses_both_ways }} €</span>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Car_toll_expenses_one_way')
														}} (€)</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="realestate.car_toll_expenses_one_way"
														   @input="set_realestate_car_toll_expenses_one_way">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Car_toll_expenses_both_ways')
														}}</label>
													<!--
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="realestate.car_toll_expenses_both_ways"
														   @input="set_realestate_car_toll_expenses_both_ways">-->
													<span>{{ realestate.car_toll_expenses_both_ways }} €</span>
												</div>
											</div>
											<!--
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Total_car_expenses_one_way')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="realestate.car_expenses_one_way"
														   @input="set_realestate_car_expenses_one_way">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Total_car_expenses_both_ways')
														}}</label>

													<span>{{ realestate.car_expenses_both_ways }} €</span>
												</div>

											</div>
											-->
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Total_travel_fees')
														}}</label>
													<!--<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="realestate.total_travel_fees"
														   @input="set_realestate_total_travel_fees">-->
													<span><strong>{{ realestate.total_travel_fees }} €</strong></span>
												</div>
											</div>

										</div>
										<div class="form-section">
											<h3>{{ $t('Appraisal_fees') }}</h3>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Acc_eco_decree_q')
														}}</label>
													<input class="field__group__input"
														   type="checkbox"
														   spellcheck="false"
														   v-model="realestate.quote_appraisal_type_is_eco"
														   @click="set_realestate_quote_appraisal_type_is_eco">
												</div>
											</div>
											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('Pre_appraisal_value')
														}}</label>
													<span>{{ realestate.pre_appraisal_value | formatNumber
														}} €</span>
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Quote_base_fees')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="realestate.quote_base_fees"
														   @input="set_realestate_quote_base_fees">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Quote_excess_pct')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="realestate.quote_excess_pct"
														   @input="set_realestate_quote_excess_pct">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Quote_base_price_coef')
														}}</label>
													<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="realestate.quote_base_price_coef"
														   @input="set_realestate_quote_base_price_coef">
												</div>
												<div class="field__group">
													<label class="field__group__label">{{ $t('Quote_base_price')
														}}</label>
													<!--<input class="field__group__input"
														   type="number"
														   spellcheck="false"
														   v-model="realestate.quote_base_price"
														   @input="set_realestate_quote_base_price">-->
													<span><strong>{{realestate.quote_base_price}} €</strong></span>
												</div>
											</div>
										</div>

										<div class="form-section">
											<h3>{{ $t('Valuation_pricing_info_table') }}</h3>
											<div class="field-container" v-if="realestate.property_type">
												<div>

													<div v-if="realestate.property_type.name_db === 'residential' || realestate.property_type.name_db === 'parking' || realestate.property_type.name_db === 'storage'">
														<h4 style="color: midnightblue">{{ $t('Dwellings')
															}}, {{ $t('Parking_spaces') }} {{ $t('and')
															}} {{ $t('Storerooms') }}</h4>
														<table class="d-table-center">
															<thead>
															<tr>
																<th>{{ $t('Appraisal_value') }} {{ $t('in_01')
																	}} {{ $t('thousands_of_euros') }}
																</th>
																<th>{{ $t('Mortgage_Appraisal_Fees') }} *<sup>1</sup>
																	*<sup>2</sup></th>
																<th>{{ $t('Informative_Appraisal_Fees')
																	}}  *<sup>2</sup></th>

															</tr>
															</thead>
															<tbody>
															<tr v-for="(range, key, index) in valuation_prices.group_A"
																v-if="index < 6">
																<td>{{ range.floor / 1000 }} a {{ range.ceil / 1000 }}
																</td>
																<td> {{ range.mortgage_valuation_fee }} €
																	<span
																			class="small"
																			v-if="range.increment_pct_mortgage_valuation > 0">
						+ {{ range.increment_pct_mortgage_valuation }} % {{ $t('of_the_excess_of')
																		}} {{ range.floor / 1000 }} {{ $t('thousand') }}
						</span>
																</td>
																<td>{{ range.standard_valuation_fee }} €
																	<span
																			class="small"
																			v-if="range.increment_pct_standard_valuation > 0">
						+ {{ range.increment_pct_standard_valuation }} % {{ $t('of_the_excess_of')
																		}} {{ range.floor / 1000 }} {{ $t('thousand') }}
						</span>
																</td>
															</tr>
															<tr>
																<td> {{ $t('Higher_values') }}</td>
																<td> {{ $t('acc_Budget') }}</td>
																<td> {{ $t('acc_Budget') }}</td>
															</tr>
															</tbody>
														</table>
													</div>
													<div v-else-if="realestate.property_type.name_db === 'retail_and_industrial' || realestate.property_type.name_db === 'office'">
														<h4 style="color: midnightblue">{{ $t('Commercial_premises')
															}}, {{ $t('Offices') }} {{ $t('and')
															}} {{ $t('Industrial_warehouses') }}</h4>

														<table class="d-table-center">
															<thead>
															<tr>
																<th>{{ $t('Appraisal_value') }} {{ $t('in_01')
																	}} {{ $t('thousands_of_euros') }}
																</th>
																<th>{{ $t('Mortgage_Appraisal_Fees') }} *<sup>1</sup>
																	*<sup>2</sup></th>
																<th>{{ $t('Informative_Appraisal_Fees')
																	}}  *<sup>2</sup></th>
															</tr>
															</thead>
															<tbody>
															<tr v-for="(range, key, index) in valuation_prices.group_B"
																v-if="index < 5">
																<td>{{ range.floor / 1000 }} a {{ range.ceil / 1000 }}
																</td>
																<td> {{ range.mortgage_valuation_fee }} €
																	<span
																			class="small"
																			v-if="range.increment_pct_mortgage_valuation > 0">
						+ {{ range.increment_pct_mortgage_valuation }} % {{ $t('of_the_excess_of')
																		}} {{ range.floor / 1000 }} {{ $t('thousand') }}
						</span>
																</td>
																<td>{{ range.standard_valuation_fee }} €
																	<span
																			class="small"
																			v-if="range.increment_pct_standard_valuation > 0">
						+ {{ range.increment_pct_standard_valuation }} % {{ $t('of_the_excess_of')
																		}} {{ range.floor / 1000 }} {{ $t('thousand') }}
						</span>
																</td>
															</tr>
															<tr>
																<td> {{ $t('Higher_values') }}</td>
																<td> {{ $t('acc_Budget') }}</td>
																<td> {{ $t('acc_Budget') }}</td>
															</tr>
															</tbody>
														</table>
													</div>
													<div v-else-if="realestate.property_type.name_db === 'entire_buildings' || realestate.property_type.name_db === 'land'">
														<h4 style="color: midnightblue">
															{{ $t('Buildings') }}, {{ $t('Property_developments')
															}}, {{ $t('Properties_under_economic_exploitation')
															}} {{ $t('and') }} {{ $t('Land_pl') }}</h4>

														<table class="d-table-center">
															<thead>
															<tr>
																<th>{{ $t('Appraisal_value') }} {{ $t('in_01')
																	}} {{ $t('thousands_of_euros') }}
																</th>
																<th>{{ $t('Fees') }} *<sup>2</sup></th>
															</tr>
															</thead>
															<tbody>
															<tr v-for="(range, key, index) in valuation_prices.group_C"
																v-if="index < 6">
																<td>{{ range.floor / 1000 }} a {{ range.ceil / 1000 }}
																</td>
																<td>{{ range.standard_valuation_fee }} €
																	<span
																			class="small"
																			v-if="range.increment_pct_standard_valuation > 0">
						+ {{ range.increment_pct_standard_valuation }} % {{ $t('of_the_excess_of')
																		}} {{ range.floor / 1000 }} {{ $t('thousand') }}
						</span>
																</td>
															</tr>
															<tr>
																<td> {{ $t('Higher_values') }}</td>
																<td> {{ $t('acc_Budget') }}</td>
															</tr>
															</tbody>
														</table>
													</div>
													<div v-else>
														<h4 style="color: midnightblue">{{ $t('Machinery')
															}}, {{ $t('Expropriations') }} {{ $t('and')
															}} {{ $t('others') }}: <span
																	style="color: gray">{{ $t('acc_Budget') }}</span>
														</h4>
													</div>
													<br>
													<span class="small">
														*<sup></sup> {{ $t('Pricing_text_03') }}.

														<br>
														*<sup>1</sup> {{ $t('Pricing_text_04') }}.
														<br>
														*<sup>2</sup> {{ $t('Pricing_text_05') }}.
													</span>

													<br>

												</div>
											</div>
										</div>

									</form>
								</div>
							</div>
						</v-tab>
						<v-tab :title="marketstudies_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Estudis de mercat')">{{marketstudies_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Market studies')">{{marketstudies_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Estudios de mercado')">{{marketstudies_text}}</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">

										<div class="form-section">
											<h3>{{ $t('Market_studies_for_this_real_estate') }}</h3>
											<!--
											<div>
												<div @click.prevent="onCreateNewMarketStudy"
													 style="width: fit-content; margin-left: auto">
													<icon-button icon="plus-circle" :text="new_marketstudy_button_text"
																 icon_color="black"
																 text_color="black"
																 border_color="lightgray"></icon-button>
												</div>
											</div>
											-->
											<div v-if="object_length(realestate_marketstudies) > 0">
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell" layout="row">
														<input type="text" :placeholder="filter_placeholder"
															   self="size-x1"
															   v-model="marketstudy_table.filter"
															   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
															   data-step="9" data-position="top">
													</div>
												</div>
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell">
														<paginator :source="object_to_array(realestate_marketstudies)"
																   :page-size="10"
																   :filter="marketstudy_table.filter"
																   data-intro="Use the paginator to page data for easier viewing"
																   data-step="10"
																   data-position="top">
															<template scope="page">
																<datatable id="data-table-marketstudy"
																		   :source="page.data"
																		   :filterable="false"
																		   :striped="marketstudy_table.striped"
																		   :editable="marketstudy_table.editable"
																		   :line-numbers="marketstudy_table.lineNumbers">
																	<datatable-column
																			v-for="column in marketstudy_table.columns"
																			:id="column.id"
																			:label="column.label"
																			:width="column.width"
																			:sortable="column.sortable"
																			:groupable="column.groupable"
																			:formatter="column.formatter">
																	</datatable-column>
																	<datatable-column id="actions-marketstudy"
																					  :label="actions_text"
																					  :sortable="false"
																					  :groupable="false"></datatable-column>
																	<template slot="actions-marketstudy" scope="cell">
																		<table class="actions-table">
																			<tr>
																				<td class="actions_td"><a
																						@click="editMarketStudy(cell.row)"
																						style="cursor: pointer;"
																						:title="edit_text">
																					<icon name="pencil" scale="1"
																						  color="gray"></icon>
																				</a></td>
																				<!--
																				<td class="actions_td">
																					<a @click="duplicateMarketStudy(cell.row)"
																					   style="cursor: pointer;"
																					   :title="duplicate_text">
																						<icon name="files-o" scale="1"
																							  color="gray"></icon>
																					</a></td>
																				<td class="actions_td"><a
																						@click="deleteMarketStudy(cell.row)"
																						style="cursor: pointer;"
																						:title="delete_text">
																					<icon name="trash-o" scale="1"
																						  color="gray"></icon>
																				</a></td>
																				-->
																			</tr>
																		</table>


																	</template>
																</datatable>
															</template>
														</paginator>
													</div>
												</div>
											</div>

										</div>


									</form>
								</div>
							</div>
						</v-tab>
						<v-tab :title="appraisals_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Taxacions')">{{appraisals_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Appraisals')">{{appraisals_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Tasaciones')">{{appraisals_text}}</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">

										<div class="form-section">
											<h3>{{ $t('Appraisals_of_the_Real_Estate') }}</h3>
											<div>
												<div @click.prevent="onCreateNewAppraisal"
													 style="width: fit-content; margin-left: auto">
													<icon-button icon="plus-circle" :text="new_appraisal_button_text"
																 icon_color="black"
																 text_color="black"
																 border_color="lightgray"></icon-button>
												</div>
											</div>
											<div v-if="object_length(realestate_appraisals) > 0">
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell" layout="row">
														<input type="text" :placeholder="filter_placeholder"
															   self="size-x1"
															   v-model="appraisal_table.filter"
															   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
															   data-step="9" data-position="top">
													</div>
												</div>
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell">
														<paginator :source="object_to_array(realestate_appraisals)"
																   :page-size="10"
																   :filter="appraisal_table.filter"
																   data-intro="Use the paginator to page data for easier viewing"
																   data-step="10"
																   data-position="top">
															<template scope="page">
																<datatable id="data-table-appraisal"
																		   :source="page.data"
																		   :filterable="false"
																		   :striped="appraisal_table.striped"
																		   :editable="appraisal_table.editable"
																		   :line-numbers="appraisal_table.lineNumbers">
																	<datatable-column
																			v-for="column in appraisal_table.columns"
																			:id="column.id"
																			:label="column.label"
																			:width="column.width"
																			:sortable="column.sortable"
																			:groupable="column.groupable"
																			:formatter="column.formatter">
																	</datatable-column>
																	<datatable-column id="actions-appraisal"
																					  :label="actions_text"
																					  :sortable="false"
																					  :groupable="false"></datatable-column>
																	<template slot="actions-appraisal" scope="cell">
																		<table class="actions-table">
																			<tr>
																				<td><a @click="editAppraisal(cell.row)"
																					   style="cursor: pointer;"
																					   :title="edit_text">
																					<icon name="pencil" scale="1"
																						  color="gray"></icon>
																				</a></td>
																				<td>
																					<a @click="duplicateAppraisal(cell.row)"
																					   style="cursor: pointer;"
																					   :title="duplicate_text">
																						<icon name="files-o" scale="1"
																							  color="gray"></icon>
																					</a></td>
																				<td>
																					<a @click="deleteAppraisal(cell.row)"
																					   style="cursor: pointer;"
																					   :title="delete_text">
																						<icon name="trash-o" scale="1"
																							  color="gray"></icon>
																					</a></td>
																			</tr>
																		</table>


																	</template>
																</datatable>
															</template>
														</paginator>
													</div>
												</div>
											</div>

										</div>


									</form>
								</div>
							</div>
						</v-tab>
						<v-tab :title="projects_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Projectes')">{{projects_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Projects')">{{projects_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Proyectos')">
								{{projects_text}}
							</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">

										<div class="form-section">
											<h3>{{ $t('Projects_of_the_Real_Estate') }}</h3>
											<div>
												<div @click.prevent="onCreateNewProject"
													 style="width: fit-content; margin-left: auto">
													<icon-button icon="plus-circle" :text="new_project_button_text"
																 icon_color="black"
																 text_color="black"
																 border_color="lightgray"></icon-button>
												</div>
											</div>
											<div v-if="object_length(realestate_projects) > 0">
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell" layout="row">
														<input type="text" :placeholder="filter_placeholder"
															   self="size-x1"
															   v-model="project_table.filter"
															   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
															   data-step="9" data-position="top">
													</div>
												</div>
												<div class="grid-row" layout="row top-stretch">
													<div class="grid-cell">
														<paginator :source="object_to_array(realestate_projects)"
																   :page-size="10"
																   :filter="project_table.filter"
																   data-intro="Use the paginator to page data for easier viewing"
																   data-step="10"
																   data-position="top">
															<template scope="page">
																<datatable id="data-table-project"
																		   :source="page.data"
																		   :filterable="false"
																		   :striped="project_table.striped"
																		   :editable="project_table.editable"
																		   :line-numbers="project_table.lineNumbers">
																	<datatable-column
																			v-for="column in project_table.columns"
																			:id="column.id"
																			:label="column.label"
																			:width="column.width"
																			:sortable="column.sortable"
																			:groupable="column.groupable"
																			:formatter="column.formatter">
																	</datatable-column>
																	<datatable-column id="actions-project"
																					  :label="actions_text"
																					  :sortable="false"
																					  :groupable="false"></datatable-column>
																	<template slot="actions-project" scope="cell">
																		<table class="actions-table">
																			<tr>
																				<td><a @click="editProject(cell.row)"
																					   style="cursor: pointer;"
																					   :title="edit_text">
																					<icon name="pencil" scale="1"
																						  color="gray"></icon>
																				</a></td>
																				<td>
																					<a @click="duplicateProject(cell.row)"
																					   style="cursor: pointer;"
																					   :title="duplicate_text">
																						<icon name="files-o" scale="1"
																							  color="gray"></icon>
																					</a></td>
																				<td>
																					<a @click="deleteProject(cell.row)"
																					   style="cursor: pointer;"
																					   :title="delete_text">
																						<icon name="trash-o" scale="1"
																							  color="gray"></icon>
																					</a></td>
																			</tr>
																		</table>


																	</template>
																</datatable>
															</template>
														</paginator>
													</div>
												</div>
											</div>

										</div>


									</form>
								</div>
							</div>
						</v-tab>
						<v-tab :title="metadata_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Versió')">{{metadata_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Version')">{{metadata_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Versión')">{{metadata_text}}
							</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="section-container">
											<h3>{{ $t('Description') }}</h3>

											<div class="field-container">
												<div class="field__group">
													<label class="field__group__label">{{ $t('RealEstate_description')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="realestate.description"
														   @input="set_realestate_description">
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</v-tab>
					</vue-tabs>


					<div>
						<div @click.prevent="onGoUp" style="width: fit-content; margin-left: auto">
							<icon-button icon="level-up" :text="goup_button_text"
										 icon_color="black"
										 text_color="black" border_color="lightgray"></icon-button>
						</div>
					</div>
					<div>
						<div @click.prevent="onSaveCurrentRealEstate({go_up: false})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<div>
						<div @click.prevent="onSaveCurrentRealEstate({go_up: true})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_and_go_up_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<message
							v-if="realestate.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>


					<!--<bar>
					</bar>
-->
				</div>
			</div>

		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import moment from 'moment'
    import 'moment/locale/ca'  // without this line it didn't work
    moment.locale('ca')
    import { dateMixin, localStorageMixin, mathMixin, colorMixin, objectsMixin } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import router from '../../../router/index.js'

    import Message from '../../../components/Message.vue'

    import countryOptions from '../../../options/countries'
    import spanishProvinceOptions from '../../../options/spanish_provinces'
    import property_typeOptions from '../../../options/property_types'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    import asset_typeOptions from '../../../options/asset_types'
    import dwelling_typeOptions from '../../../options/dwelling_types'

    import floor_typeOptions from '../../../options/floor_types'

    export default {
        name: 'realestate-editor',

        mixins: [
            dateMixin,
            localStorageMixin,
            mathMixin,
            objectsMixin,
            colorMixin
        ],

        data: () => ({
            master_loading: true,
            check_prices_loading: false,
            tabName: '',
            currentTabTitle: '',
            google_map_offset: 0.00005,
            google_map_size: '640x480',
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            cadaster_ref_loading: false,
            icc_census_section_loading: false,
            google_geocode_loading: false,
            error: null,
            success_message: null,
            google_map_01_loading: false,
            google_map_02_loading: false,
            google_map_03_loading: false,
            metadata_text: Vue.i18n.translate('Version'),
            identification_text: Vue.i18n.translate('Identification') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('pre_appraisal'),
            marketstudies_text: Vue.i18n.translate('Market_studies'),
            appraisals_text: Vue.i18n.translate('Appraisals'),
            projects_text: Vue.i18n.translate('Projects'),
            appraisal_cost_text: Vue.i18n.translate('Appraisal_cost'),
            quote_text: Vue.i18n.translate('Quote'),
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            new_appraisal_button_text: Vue.i18n.translate('Add_appraisal'),
            new_project_button_text: Vue.i18n.translate('Add_project'),
            new_marketstudy_button_text: Vue.i18n.translate('Add_market_study'),
            cancel_button_text: Vue.i18n.translate('Cancel'),
            goback_button_text: Vue.i18n.translate('Go_back') + ' ' + Vue.i18n.translate('without_saving'),
            goup_button_text: Vue.i18n.translate('Go_up') + ' ' + Vue.i18n.translate('without_saving'),
            save_button_text: Vue.i18n.translate('Save'),
            save_and_go_up_button_text: Vue.i18n.translate('Save') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('go_up'),
            cad_ref_error_text_01: Vue.i18n.translate('Cadastral_Reference_less_20_positions_error_text'),
            page_dirty_text: Vue.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: Vue.i18n.translate('Actions'),
            duplicate_text: Vue.i18n.translate('Duplicate'),
            edit_text: Vue.i18n.translate('Edit'),
            delete_text: Vue.i18n.translate('Delete'),
            countryOptions,
            property_typeOptions,
            spanishProvinceOptions,
            countryValue: null,
            property_typeValue: null,
            municipalityValue: null,
            provinceValue: null,
            asset_typeValue: null,
            dwelling_typeValue: null,
            floor_typeValue: null,
            floor_typeOptions,
            asset_typeOptions,
            dwelling_typeOptions,
            mapStyles: [
                {
                    featureType: 'poi',
                    elementType: 'labels',
                    stylers: [
                        {
                            visibility: 'off'
                        }
                    ]
                }
            ],
            appraisal_table: {
                striped: true,
                editable:
                    false,
                lineNumbers:
                    true,
                filter:
                    null,
                currency:
                    'EUR',
                dateFormat:
                    'DD/MM/YYYY',
                columns:
                    [
                        {
                            id: 'description',
                            label: Vue.i18n.translate('Description'),
                            width: null,
                            sortable: true,
                            groupable: false,
                            aggregators: []
                        },
                        {
                            id: 'date_modified',
                            label: Vue.i18n.translate('Last_modified'),
                            width: null,
                            sortable: true,
                            groupable: false,
                            aggregators: [],
                            formatter: function (value) {
                                return moment(value).format('DD/MM/YYYY HH:mm:ss')
                            }
                        }
                    ],
                selected:
                    []
            },
            project_table: {
                striped: true,
                editable:
                    false,
                lineNumbers:
                    true,
                filter:
                    null,
                currency:
                    'EUR',
                dateFormat:
                    'DD/MM/YYYY',
                columns:
                    [
                        {
                            id: 'description',
                            label: Vue.i18n.translate('Description'),
                            width: null,
                            sortable: true,
                            groupable: false,
                            aggregators: []
                        },
                        {
                            id: 'date_modified',
                            label: Vue.i18n.translate('Last_modified'),
                            width: null,
                            sortable: true,
                            groupable: false,
                            aggregators: [],
                            formatter: function (value) {
                                return moment(value).format('DD/MM/YYYY HH:mm:ss')
                            }
                        }
                    ],
                selected:
                    []
            }
            ,
            marketstudy_table: {
                striped: true,
                editable:
                    false,
                lineNumbers:
                    true,
                filter:
                    null,
                currency:
                    'EUR',
                dateFormat:
                    'DD/MM/YYYY',
                columns:
                    [
                        {
                            id: 'description',
                            label: Vue.i18n.translate('Description'),
                            width: null,
                            sortable: true,
                            groupable: false,
                            aggregators: []
                        },
                        {
                            id: 'appraisal_id',
                            label: Vue.i18n.translate('Appraisal'),
                            width: null,
                            sortable: true,
                            groupable: false,
                            aggregators: []
                        },
                        {
                            id: 'date_modified',
                            label: Vue.i18n.translate('Last_modified'),
                            width: null,
                            sortable: true,
                            groupable: false,
                            aggregators: [],
                            formatter: function (value) {
                                return moment(value).format('DD/MM/YYYY HH:mm:ss')
                            }
                        }
                    ],
                selected:
                    []
            }

        }),

        created () {
            this.FETCH_VALUATION_PRICES({path: 'valuation_prices' + '/'}).then(() => {
                this.FETCH_REALESTATE_MARKETSTUDIES({path: 'realestate_marketstudies' + '/' + this.realestate.id + '/'}).then(() => {
                    this.FETCH_REALESTATE_APPRAISALS({path: 'realestate_appraisals' + '/' + this.realestate.id + '/'}).then(() => {
                        this.FETCH_REALESTATE_PROJECTS({path: 'realestate_projects' + '/' + this.realestate.id + '/'}).then(() => {
                            if (this.realestate.province && !this.realestate_municipalities.municipalities) {

                                if (this.realestate.province.ine_province_code) {
                                    console.log('fetching...')
                                    this.FETCH_REALESTATE_MUNICIPALITIES({path: 'municipalities' + '/' + 'province_' + this.realestate.province.ine_province_code + '/'}).then(() => {

                                        this.master_loading = false

                                    })
                                } else {

                                    this.master_loading = false
                                }

                            } else {

                                this.master_loading = false
                            }
                        })
                    })
                })
            })
        }
        ,

        components: {
            Bar,
            Message,
            IconButton,
            Spinner,
            Checkbox,
            Datatable,
            DatatableColumn,
            Paginator,
            SideNavBar
        }
        ,

        computed: {
            ...
                mapGetters([
                    'theme',
                    'appraisal',
                    'appraisalfile',
                    'appraisalreport',
                    'appraisalreport_realestates',
                    'currentLocale',
                    'marketstudy',
                    'project',
                    'realestate',
                    'realestate_appraisals',
                    'realestate_marketstudies',
                    'realestate_municipalities',
                    'realestate_projects',
                    'valuation_prices'
                ]),
            prices_startdate: function () {
                return moment().subtract(6, 'months').format('YYYY-MM-DD')
            },
            prices_limitdate: function () {
                return moment().format('YYYY-MM-DD')
            },
            prices_startdate_readformat: function () {
                return moment().subtract(6, 'months').format('DD MMMM YYYY')
            },
            prices_limitdate_readformat: function () {
                return moment().format('DD MMMM YYYY')
            }
        }
        ,

        methods: {
            ...
                mapActions(
                    [
                        'CREATE_NEW_APPRAISAL',
                        'CREATE_NEW_MARKETSTUDY',
                        'CREATE_NEW_PROJECT',
                        'DELETE_MARKETSTUDY',
                        'DELETE_APPRAISAL',
                        'DELETE_PROJECT',
                        'FETCH_REALESTATE_APPRAISALS',
                        'FETCH_REALESTATE_MARKETSTUDIES',
                        'FETCH_REALESTATE_MUNICIPALITIES',
                        'FETCH_REALESTATE_PROJECTS',
                        'GEOLOCATE_REALESTATE',
                        'GOOGLEDISTANCE_REALESTATE',
                        'FETCH_VALUATION_PRICES',
                        'REQUEST_CADASTRAL_REFERENCE_BY_COORDINATES',
                        'REQUEST_CENSUS_SECTION_INFO',
                        'RESET_APPRAISAL',
                        'RESET_MARKETSTUDY',
                        'RESET_PROJECT',
                        'SET_APPRAISAL',
                        'SET_APPRAISAL_FLOOR_NUMBER_BY_KEY',
                        'SET_APPRAISAL_PROPERTY_TYPE_BY_KEY',
                        'SET_MARKETSTUDY',
                        'SET_REALESTATE_CADASTRAL_REFERENCE',
                        'SET_REALESTATE_CENSUS_SECTION_CODE',
                        'SET_REALESTATE_COUNTRY',
                        'SET_REALESTATE_DESCRIPTION',
                        'SET_REALESTATE_DOOR',
                        'SET_REALESTATE_EPSG25831_X',
                        'SET_REALESTATE_EPSG25831_Y',
                        'SET_REALESTATE_FLOOR',
                        'SET_REALESTATE_FLOOR_NUMBER',
                        'SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS',
                        'SET_REALESTATE_LAT',
                        'SET_REALESTATE_LNG',
                        'SET_REALESTATE_MUNICIPALITY',
                        'SET_REALESTATE_POSTAL_CODE',
                        'SET_REALESTATE_PROPERTY_TYPE',
                        'SET_REALESTATE_REGISTRY_NAME',
                        'SET_REALESTATE_PROVINCE',
                        'SET_REALESTATE_STAIRCASE',
                        'SET_REALESTATE_STREET_NAME',
                        'SET_REALESTATE_STREET_NUMBER',
                        'SET_REALESTATE_MAP_GOOGLE_01_URL',
                        'SET_REALESTATE_MAP_GOOGLE_01_LAT',
                        'SET_REALESTATE_MAP_GOOGLE_01_LNG',
                        'SET_REALESTATE_MAP_GOOGLE_01_ZOOM',
                        'SET_REALESTATE_MAP_GOOGLE_02_URL',
                        'SET_REALESTATE_MAP_GOOGLE_02_LAT',
                        'SET_REALESTATE_MAP_GOOGLE_02_LNG',
                        'SET_REALESTATE_MAP_GOOGLE_02_ZOOM',
                        'SET_REALESTATE_MAP_GOOGLE_03_URL',
                        'SET_REALESTATE_MAP_GOOGLE_03_LAT',
                        'SET_REALESTATE_MAP_GOOGLE_03_LNG',
                        'SET_REALESTATE_MAP_GOOGLE_03_ZOOM',
                        'SET_REALESTATE_FULL_ADDRESS',
                        'SET_REALESTATE_SHORT_ADDRESS',
                        'SET_REALESTATE_BLOCK',
                        'SET_REALESTATE_AREA_ADS_MARKERS',
                        'SET_REALESTATE_AREA_AVERAGE_PRICE',
                        'SET_REALESTATE_AREA_AVERAGE_PRICE_COEF',
                        'SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE',
                        'SET_REALESTATE_ESTIMATED_BUILT_AREA',
                        'SET_REALESTATE_PRE_APPRAISAL_VALUE',
                        'SET_REALESTATE_TRAVEL_ONE_WAY_HOURS',
                        'SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS',
                        'SET_REALESTATE_TRAVEL_FEES_PER_HOUR',
                        'SET_REALESTATE_CAR_FUEL_EXPENSES_ONE_WAY',
                        'SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS',
                        'SET_REALESTATE_CAR_TOLL_EXPENSES_ONE_WAY',
                        'SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS',
                        'SET_REALESTATE_CAR_EXPENSES_ONE_WAY',
                        'SET_REALESTATE_CAR_EXPENSES_BOTH_WAYS',
                        'SET_REALESTATE_TOTAL_TRAVEL_FEES',
                        'SET_REALESTATE_QUOTE_BASE_FEES',
                        'SET_REALESTATE_QUOTE_EXCESS_PCT',
                        'SET_REALESTATE_QUOTE_EXCESS',
                        'SET_REALESTATE_QUOTE_BASE_PRICE',
                        'SET_REALESTATE_QUOTE_BASE_PRICE_COEF',
                        'SET_REALESTATE_QUOTE_APPRAISAL_TYPE_IS_ECO',
                        'SET_REALESTATE_AREA_ADS_QUERY_STARTDATE',
                        'SET_REALESTATE_AREA_ADS_QUERY_LIMITDATE',
                        'SET_REALESTATE_AREA_ADS_QUERY_DISTANCE',
                        'SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES',
                        'SET_REALESTATE_ASSET_TYPE',
                        'SET_REALESTATE_DWELLING_TYPE',
                        'SET_REALESTATE_FLOOR_TYPE',
                        'QUERY_ADS',
                        'UPDATE_REALESTATE'
                    ]),
            backgroundStyle: function (value) {
                // console.log('step2: ')
                // console.log(value)
                return {
                    'background-color': this.getColor(value)
                }
            },
            setCurrentTabTitle: function (tabTitle) {
                console.log('hey, current Tab Title: ' + tabTitle)
                this.currentTabTitle = tabTitle
            },
            setCurrentTab: function (tabTitle) {
                console.log('hey, current Tab: ' + tabTitle)
                this.tabName = tabTitle
            },
            set_realestate_cadastral_reference:
                _.debounce(function (e) {
                    this.SET_REALESTATE_CADASTRAL_REFERENCE(e.target.value)
                }, 1000),
            set_realestate_census_section_code:
                _.debounce(function (e) {
                    this.SET_REALESTATE_CENSUS_SECTION_CODE(e.target.value)
                }, 1000),
            set_realestate_full_address:
                _.debounce(function (e) {
                    this.SET_REALESTATE_FULL_ADDRESS(e.target.value)
                }, 0),
            set_realestate_short_address:
                _.debounce(function (e) {
                    this.SET_REALESTATE_SHORT_ADDRESS(e.target.value)
                }, 0),
            set_realestate_country_option:
                _.debounce(function (e) {
                    console.log('set_realestate_country e: ')
                    console.log(e)
                    this.SET_REALESTATE_COUNTRY(e)

                    this.SET_REALESTATE_PROVINCE(null)
                    this.realestate.province = null

                    this.SET_REALESTATE_MUNICIPALITY(null)
                    this.realestate.municipality = null

                    this.SET_REALESTATE_LAT(null)
                    this.realestate.lat = null

                    this.SET_REALESTATE_LNG(null)
                    this.realestate.lng = null

                    this.SET_REALESTATE_EPSG25831_X(null)
                    this.realestate.epsg25831_x = null

                    this.SET_REALESTATE_EPSG25831_Y(null)
                    this.realestate.epsg25831_y = null

                    this.SET_REALESTATE_CADASTRAL_REFERENCE(null)
                    this.realestate.cadastral_reference = null

                    this.SET_REALESTATE_CENSUS_SECTION_CODE(null)
                    this.realestate.census_section_code = null

                    this.SET_REALESTATE_POSTAL_CODE(null)
                    this.realestate.postal_code = null

                    this.SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS(null)
                    this.realestate.google_formatted_address = null

                }, 1000),
            set_realestate_description:
                _.debounce(function (e) {
                    this.SET_REALESTATE_DESCRIPTION(e.target.value)
                }, 1000),
            set_realestate_door:
                _.debounce(function (e) {

                    let street_name = ''
                    let street_number = ''
                    let floor = ''
                    let door = e.target.value
                    let staircase = ''
                    let block = ''
                    let postal_code = ''
                    let municipality = ''
                    let full_address = ''

                    if (this.realestate.street_name) {
                        street_name = this.realestate.street_name
                        full_address = street_name
                    }

                    if (this.realestate.street_number) {
                        street_number = this.realestate.street_number
                        full_address = full_address + ', ' + street_number
                    }

                    if (this.realestate.floor) {
                        floor = this.realestate.floor
                        full_address = full_address + ', ' + floor
                    }

                    if (this.realestate.floor) {
                        full_address = full_address + ' ' + door
                    } else {
                        full_address = full_address + Vue.i18n.translate('door') + ' ' + door
                    }

                    if (this.realestate.staircase) {
                        staircase = this.realestate.staircase
                        full_address = full_address + ', ' + Vue.i18n.translate('staircase') + ' ' + staircase
                    }

                    if (this.realestate.block) {
                        block = this.realestate.block
                        full_address = full_address + ', ' + Vue.i18n.translate('block') + ' ' + block
                    }

                    if (this.realestate.postal_code) {
                        postal_code = this.realestate.postal_code
                        full_address = full_address + ', ' + postal_code
                    }

                    if (this.realestate.municipality) {
                        municipality = this.realestate.municipality.name_ine
                        full_address = full_address + ', ' + municipality
                    }

                    this.SET_REALESTATE_FULL_ADDRESS(full_address)

                    this.SET_REALESTATE_DOOR(e.target.value)
                }, 1000),
            set_realestate_epsg25831_x:
                _.debounce(function (e) {
                    this.SET_REALESTATE_EPSG25831_X(e.target.value)
                }, 1000),
            set_realestate_epsg25831_y:
                _.debounce(function (e) {
                    this.SET_REALESTATE_EPSG25831_Y(e.target.value)
                }, 1000),
            set_realestate_floor:
                _.debounce(function (e) {
                    this.SET_REALESTATE_FLOOR(e.target.value)

                    let street_name = ''
                    let street_number = ''
                    let floor = e.target.value
                    let door = ''
                    let staircase = ''
                    let block = ''
                    let postal_code = ''
                    let municipality = ''
                    let full_address = ''

                    if (this.realestate.street_name) {
                        street_name = this.realestate.street_name
                        full_address = street_name
                    }

                    if (this.realestate.street_number) {
                        street_number = this.realestate.street_number
                        full_address = full_address + ', ' + street_number
                    }

                    full_address = full_address + ', ' + floor

                    if (this.realestate.door) {
                        door = this.realestate.door
                        if (this.realestate.floor) {
                            full_address = full_address + ' ' + door
                        } else {
                            full_address = full_address + Vue.i18n.translate('door') + ' ' + door
                        }

                    }

                    if (this.realestate.staircase) {
                        staircase = this.realestate.staircase
                        full_address = full_address + ', ' + Vue.i18n.translate('staircase') + ' ' + staircase
                    }

                    if (this.realestate.block) {
                        block = this.realestate.block
                        full_address = full_address + ', ' + Vue.i18n.translate('block') + ' ' + block
                    }

                    if (this.realestate.postal_code) {
                        postal_code = this.realestate.postal_code
                        full_address = full_address + ', ' + postal_code
                    }

                    if (this.realestate.municipality) {
                        municipality = this.realestate.municipality.name_ine
                        full_address = full_address + ', ' + municipality
                    }

                    this.SET_REALESTATE_FULL_ADDRESS(full_address)

                }, 1000),
            set_realestate_block:
                _.debounce(function (e) {
                    this.SET_REALESTATE_BLOCK(e.target.value)

                    let street_name = ''
                    let street_number = ''
                    let floor = ''
                    let door = ''
                    let staircase = ''
                    let block = e.target.value
                    let postal_code = ''
                    let municipality = ''
                    let full_address = ''

                    if (this.realestate.street_name) {
                        street_name = this.realestate.street_name
                        full_address = street_name
                    }

                    if (this.realestate.street_number) {
                        street_number = this.realestate.street_number
                        full_address = full_address + ', ' + street_number
                    }

                    if (this.realestate.floor) {
                        floor = this.realestate.floor
                        full_address = full_address + ', ' + floor
                    }

                    if (this.realestate.door) {
                        door = this.realestate.door
                        if (this.realestate.floor) {
                            full_address = full_address + ' ' + door
                        } else {
                            full_address = full_address + Vue.i18n.translate('door') + ' ' + door
                        }

                    }

                    if (this.realestate.staircase) {
                        staircase = this.realestate.staircase
                        full_address = full_address + ', ' + Vue.i18n.translate('staircase') + ' ' + staircase
                    }

                    full_address = full_address + ', ' + Vue.i18n.translate('block') + ' ' + block

                    if (this.realestate.postal_code) {
                        postal_code = this.realestate.postal_code
                        full_address = full_address + ', ' + postal_code
                    }

                    if (this.realestate.municipality) {
                        municipality = this.realestate.municipality.name_ine
                        full_address = full_address + ', ' + municipality
                    }

                    this.SET_REALESTATE_FULL_ADDRESS(full_address)

                }, 1000),
            set_realestate_floor_number:
                _.debounce(function (e) {
                    let floor_number = e.target.value
                    console.log('hola!')
                    // TODO: al canviar aquest paràmetre s'hauria d'actualitzar els estudis de mercat de les diferents taxacions d'aquest immoble i també el de les taxacions
                    this.SET_REALESTATE_FLOOR_NUMBER(floor_number)

                    _.forEach(this.realestate_appraisals, (value, key) => {
                        // console.log('appraisal key: ')
                        // console.log(key)
                        this.SET_APPRAISAL_FLOOR_NUMBER_BY_KEY({
                            realestate_id: this.realestate.id,
                            appraisal_id: key,
                            floor_number: floor_number
                        })

                    })

                }, 1000),
            set_realestate_lat:
                _.debounce(function (e) {
                    this.SET_REALESTATE_LAT(e.target.value)
                }, 1000),
            set_realestate_lng:
                _.debounce(function (e) {
                    this.SET_REALESTATE_LNG(e.target.value)
                }, 1000),
            set_realestate_municipality:
                _.debounce(function (e) {
                    this.SET_REALESTATE_MUNICIPALITY(e.target.value)

                    let street_name = ''
                    let street_number = ''
                    let floor = ''
                    let door = ''
                    let staircase = ''
                    let block = ''
                    let postal_code = ''
                    let municipality = e.target.value
                    let full_address = ''

                    if (this.realestate.street_name) {
                        street_name = this.realestate.street_name
                        full_address = street_name
                    }

                    if (this.realestate.street_number) {
                        street_number = this.realestate.street_number
                        full_address = full_address + ', ' + street_number
                    }

                    if (this.realestate.floor) {
                        floor = this.realestate.floor
                        full_address = full_address + ', ' + floor
                    }

                    if (this.realestate.door) {
                        door = this.realestate.door
                        if (this.realestate.floor) {
                            full_address = full_address + ' ' + door
                        } else {
                            full_address = full_address + Vue.i18n.translate('door') + ' ' + door
                        }

                    }

                    if (this.realestate.staircase) {
                        staircase = this.realestate.staircase
                        full_address = full_address + ', ' + Vue.i18n.translate('staircase') + ' ' + staircase
                    }

                    if (this.realestate.block) {
                        block = this.realestate.block
                        full_address = full_address + ', ' + Vue.i18n.translate('block') + ' ' + block
                    }

                    if (this.realestate.postal_code) {
                        postal_code = this.realestate.postal_code
                        full_address = full_address + ', ' + postal_code
                    }

                    full_address = full_address + ', ' + municipality

                    this.SET_REALESTATE_FULL_ADDRESS(full_address)

                }, 1000),
            set_realestate_municipality_option:
                _.debounce(function (e) {
                    this.SET_REALESTATE_MUNICIPALITY(e)
                }, 1000),
            set_realestate_postal_code:
                _.debounce(function (e) {
                    this.SET_REALESTATE_POSTAL_CODE(e.target.value)

                    let street_name = ''
                    let street_number = ''
                    let floor = ''
                    let door = ''
                    let staircase = ''
                    let block = ''
                    let postal_code = e.target.value
                    let municipality = ''
                    let full_address = ''

                    if (this.realestate.street_name) {
                        street_name = this.realestate.street_name
                        full_address = street_name
                    }

                    if (this.realestate.street_number) {
                        street_number = this.realestate.street_number
                        full_address = full_address + ', ' + street_number
                    }

                    if (this.realestate.floor) {
                        floor = this.realestate.floor
                        full_address = full_address + ', ' + floor
                    }

                    if (this.realestate.door) {
                        door = this.realestate.door
                        if (this.realestate.floor) {
                            full_address = full_address + ' ' + door
                        } else {
                            full_address = full_address + Vue.i18n.translate('door') + ' ' + door
                        }

                    }

                    if (this.realestate.staircase) {
                        staircase = this.realestate.staircase
                        full_address = full_address + ', ' + Vue.i18n.translate('staircase') + ' ' + staircase
                    }

                    if (this.realestate.block) {
                        block = this.realestate.block
                        full_address = full_address + ', ' + Vue.i18n.translate('block') + ' ' + block
                    }

                    full_address = full_address + ', ' + postal_code

                    if (this.realestate.municipality) {
                        municipality = this.realestate.municipality.name_ine
                        full_address = full_address + ', ' + municipality
                    }

                    this.SET_REALESTATE_FULL_ADDRESS(full_address)

                }, 1000),
            set_realestate_property_type:
                _.debounce(function (e) {

                    let property_type = e
                    this.SET_REALESTATE_PROPERTY_TYPE(property_type)

                    // Si es canvia el tipus d'immoble actualitzar els honoraris
                    if (this.realestate.pre_appraisal_value) {
                        this.set_base_fees(this.realestate.pre_appraisal_value)
                    }

                    _.forEach(this.realestate_appraisals, (value, key) => {
                        // console.log('appraisal key: ')
                        // console.log(key)
                        this.SET_APPRAISAL_PROPERTY_TYPE_BY_KEY({
                            realestate_id: this.realestate.id,
                            appraisal_id: key,
                            property_type: property_type
                        })

                    })

                    if (property_type.name_es === 'Garaje') {

                        let asset_obj = {
                                bde_code: 'V98',
                                name_es: 'V98 - Plazas de garaje',
                                name_ca: 'V98 - Places d\'aparcament',
                                name_en: 'V98 - Parking spaces',
                                lifespan: 100
                            }

                        let dwelling_obj = {
                            id: 0,
                            bde_code: 0,
                            name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                            name_en: '0 - Not applicable, the real estate is not a housing type',
                            name_es: '0 - No se aplica, al no tratarse de vivienda'
                        }

                        this.SET_REALESTATE_ASSET_TYPE(asset_obj)
                        this.SET_REALESTATE_DWELLING_TYPE(dwelling_obj)
                    }else if (property_type.name_es === 'Plaza de aparcamiento') {

                        let asset_obj = {
                            bde_code: 'V98',
                            name_es: 'V98 - Plazas de garaje',
                            name_ca: 'V98 - Places d\'aparcament',
                            name_en: 'V98 - Parking spaces',
                            lifespan: 100
                        }

                        let dwelling_obj = {
                            id: 0,
                            bde_code: 0,
                            name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                            name_en: '0 - Not applicable, the real estate is not a housing type',
                            name_es: '0 - No se aplica, al no tratarse de vivienda'
                        }

                        this.SET_REALESTATE_ASSET_TYPE(asset_obj)
                        this.SET_REALESTATE_DWELLING_TYPE(dwelling_obj)
                    }else if (property_type.name_es === 'Trastero') {

                        let asset_obj = {
                            bde_code: 'V99',
                            name_es: 'V99 - Trasteros',
                            name_ca: 'V99 - Trasters',
                            name_en: 'V99 - Storage rooms',
                            lifespan: 100
                        }

                        let dwelling_obj = {
                            id: 0,
                            bde_code: 0,
                            name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                            name_en: '0 - Not applicable, the real estate is not a housing type',
                            name_es: '0 - No se aplica, al no tratarse de vivienda'
                        }

                        this.SET_REALESTATE_ASSET_TYPE(asset_obj)
                        this.SET_REALESTATE_DWELLING_TYPE(dwelling_obj)
                    }else if (property_type.name_es === 'Trastero') {

                        let asset_obj = {
                            bde_code: 'V99',
                            name_es: 'V99 - Trasteros',
                            name_ca: 'V99 - Trasters',
                            name_en: 'V99 - Storage rooms',
                            lifespan: 100
                        }

                        let dwelling_obj = {
                            id: 0,
                            bde_code: 0,
                            name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                            name_en: '0 - Not applicable, the real estate is not a housing type',
                            name_es: '0 - No se aplica, al no tratarse de vivienda'
                        }

                        this.SET_REALESTATE_ASSET_TYPE(asset_obj)
                        this.SET_REALESTATE_DWELLING_TYPE(dwelling_obj)
                    }else if (property_type.name_es === 'Piscina') {

                        let asset_obj = {
                            bde_code: 'VA3',
                            name_es: 'VA3 - Resto de los edificios',
                            name_ca: 'VA3 - Altres edificis',
                            name_en: 'VA3 - Other buildings',
                            lifespan: 50
                        }

                        let dwelling_obj = {
                            id: 0,
                            bde_code: 0,
                            name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                            name_en: '0 - Not applicable, the real estate is not a housing type',
                            name_es: '0 - No se aplica, al no tratarse de vivienda'
                        }

                        this.SET_REALESTATE_ASSET_TYPE(asset_obj)
                        this.SET_REALESTATE_DWELLING_TYPE(dwelling_obj)
                    }else if (property_type.name_es === 'Pista deportiva') {

                        let asset_obj = {
                            bde_code: 'VA3',
                            name_es: 'VA3 - Resto de los edificios',
                            name_ca: 'VA3 - Altres edificis',
                            name_en: 'VA3 - Other buildings',
                            lifespan: 50
                        }

                        let dwelling_obj = {
                            id: 0,
                            bde_code: 0,
                            name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                            name_en: '0 - Not applicable, the real estate is not a housing type',
                            name_es: '0 - No se aplica, al no tratarse de vivienda'
                        }

                        this.SET_REALESTATE_ASSET_TYPE(asset_obj)
                        this.SET_REALESTATE_DWELLING_TYPE(dwelling_obj)
                    }else if (property_type.name_es === 'Club deportivo') {

                        let asset_obj = {
                            bde_code: 'VA3',
                            name_es: 'VA3 - Resto de los edificios',
                            name_ca: 'VA3 - Altres edificis',
                            name_en: 'VA3 - Other buildings',
                            lifespan: 50
                        }

                        let dwelling_obj = {
                            id: 0,
                            bde_code: 0,
                            name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                            name_en: '0 - Not applicable, the real estate is not a housing type',
                            name_es: '0 - No se aplica, al no tratarse de vivienda'
                        }

                        this.SET_REALESTATE_ASSET_TYPE(asset_obj)
                        this.SET_REALESTATE_DWELLING_TYPE(dwelling_obj)
                    }else if (property_type.name_es === 'Local con acceso directo') {

                        let asset_obj = {
                            bde_code: 'V97',
                            name_es: 'V97 - Locales comerciales',
                            name_ca: 'V97 - Locals comercials',
                            name_en: 'V97 - Retail',
                            lifespan: 50
                        }

                        let dwelling_obj = {
                            id: 0,
                            bde_code: 0,
                            name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                            name_en: '0 - Not applicable, the real estate is not a housing type',
                            name_es: '0 - No se aplica, al no tratarse de vivienda'
                        }

                        this.SET_REALESTATE_ASSET_TYPE(asset_obj)
                        this.SET_REALESTATE_DWELLING_TYPE(dwelling_obj)
                    }else if (property_type.name_es === 'Local sin acceso directo') {

                        let asset_obj = {
                            bde_code: 'V97',
                            name_es: 'V97 - Locales comerciales',
                            name_ca: 'V97 - Locals comercials',
                            name_en: 'V97 - Retail',
                            lifespan: 50
                        }

                        let dwelling_obj = {
                            id: 0,
                            bde_code: 0,
                            name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                            name_en: '0 - Not applicable, the real estate is not a housing type',
                            name_es: '0 - No se aplica, al no tratarse de vivienda'
                        }

                        this.SET_REALESTATE_ASSET_TYPE(asset_obj)
                        this.SET_REALESTATE_DWELLING_TYPE(dwelling_obj)
                    }else if (property_type.name_es === 'Nave industrial') {

                        let asset_obj =  {
                            bde_code: 'VA3',
                            name_es: 'VA3 - Resto de los edificios',
                            name_ca: 'VA3 - Altres edificis',
                            name_en: 'VA3 - Other buildings',
                            lifespan: 35
                        }

                        let dwelling_obj = {
                            id: 0,
                            bde_code: 0,
                            name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                            name_en: '0 - Not applicable, the real estate is not a housing type',
                            name_es: '0 - No se aplica, al no tratarse de vivienda'
                        }

                        this.SET_REALESTATE_ASSET_TYPE(asset_obj)
                        this.SET_REALESTATE_DWELLING_TYPE(dwelling_obj)
                    }else if (property_type.name_es === 'Escuela') {

                        let asset_obj = {
                            bde_code: 'VA3',
                            name_es: 'VA3 - Resto de los edificios',
                            name_ca: 'VA3 - Altres edificis',
                            name_en: 'VA3 - Other buildings',
                            lifespan: 50
                        }

                        let dwelling_obj = {
                            id: 0,
                            bde_code: 0,
                            name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                            name_en: '0 - Not applicable, the real estate is not a housing type',
                            name_es: '0 - No se aplica, al no tratarse de vivienda'
                        }

                        this.SET_REALESTATE_ASSET_TYPE(asset_obj)
                        this.SET_REALESTATE_DWELLING_TYPE(dwelling_obj)
                    }else if (property_type.name_es === 'Hotel') {

                        let asset_obj = {
                            bde_code: 'VA1',
                            name_es: 'VA1 - Hoteles',
                            name_ca: 'VA1 - Hotels',
                            name_en: 'VA1 - Hotels',
                            lifespan: 50
                        }

                        let dwelling_obj = {
                            id: 0,
                            bde_code: 0,
                            name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                            name_en: '0 - Not applicable, the real estate is not a housing type',
                            name_es: '0 - No se aplica, al no tratarse de vivienda'
                        }

                        this.SET_REALESTATE_ASSET_TYPE(asset_obj)
                        this.SET_REALESTATE_DWELLING_TYPE(dwelling_obj)
                    }

                }, 500),
            set_realestate_province:
                _.debounce(function (e) {
                    this.SET_REALESTATE_PROVINCE(e.target.value).then((res) => {
                        this.SET_REALESTATE_MUNICIPALITY(null)
                        this.realestate.municipality = null
                    })
                }, 1000),
            set_realestate_province_option:
                _.debounce(function (e) {
                    this.SET_REALESTATE_PROVINCE(e).then((res) => {
                        this.FETCH_REALESTATE_MUNICIPALITIES({path: 'municipalities' + '/' + 'province_' + this.realestate.province.ine_province_code + '/'})
                        this.SET_REALESTATE_MUNICIPALITY(null)
                        this.realestate.municipality = null
                    })
                }, 1000),
            set_realestate_registry_name:
                _.debounce(function (e) {
                    this.SET_REALESTATE_REGISTRY_NAME(e.target.value)
                }, 1000),
            set_realestate_staircase:
                _.debounce(function (e) {

                    let street_name = ''
                    let street_number = ''
                    let floor = ''
                    let door = ''
                    let staircase = e.target.value
                    let block = ''
                    let postal_code = ''
                    let municipality = ''
                    let full_address = ''

                    if (this.realestate.street_name) {
                        street_name = this.realestate.street_name
                        full_address = street_name
                    }

                    if (this.realestate.street_number) {
                        floor = this.realestate.street_number
                        full_address = full_address + ', ' + street_number
                    }

                    if (this.realestate.floor) {
                        floor = this.realestate.floor
                        if (this.realestate.floor) {
                            full_address = full_address + '-' + floor
                        } else {
                            full_address = full_address + Vue.i18n.translate('floor') + ' ' + floor
                        }

                    }

                    if (this.realestate.door) {
                        door = this.realestate.door
                        if (this.realestate.door) {
                            full_address = full_address + ' ' + door
                        } else {
                            full_address = full_address + Vue.i18n.translate('door') + ' ' + door
                        }

                    }

                    full_address = full_address + ', ' + Vue.i18n.translate('staircase') + ' ' + staircase

                    if (this.realestate.block) {
                        block = this.realestate.block
                        full_address = full_address + ', ' + Vue.i18n.translate('block') + ' ' + block
                    }

                    if (this.realestate.postal_code) {
                        postal_code = this.realestate.postal_code
                        full_address = full_address + ', ' + postal_code
                    }

                    if (this.realestate.municipality) {
                        municipality = this.realestate.municipality.name_ine
                        full_address = full_address + ', ' + municipality
                    }

                    this.SET_REALESTATE_STAIRCASE(e.target.value)
                }, 1000),
            set_realestate_street_name:
                _.debounce(function (e) {

                    let street_name = e.target.value
                    let street_number = ''
                    let floor = ''
                    let door = ''
                    let staircase = ''
                    let block = ''
                    let postal_code = ''
                    let municipality = ''
                    let full_address = ''

                    full_address = street_name

                    if (this.realestate.street_number) {
                        street_number = this.realestate.street_number
                        full_address = full_address + ', ' + street_number
                    }

                    if (this.realestate.floor) {
                        floor = this.realestate.floor
                        full_address = full_address + ', ' + floor
                    }

                    if (this.realestate.door) {
                        door = this.realestate.door
                        if (this.realestate.floor) {
                            full_address = full_address + ' ' + door
                        } else {
                            full_address = full_address + Vue.i18n.translate('door') + ' ' + door
                        }

                    }

                    if (this.realestate.staircase) {
                        staircase = this.realestate.staircase
                        full_address = full_address + ', ' + Vue.i18n.translate('staircase') + ' ' + staircase
                    }

                    if (this.realestate.block) {
                        block = this.realestate.block
                        full_address = full_address + ', ' + Vue.i18n.translate('block') + ' ' + block
                    }

                    if (this.realestate.postal_code) {
                        postal_code = this.realestate.postal_code
                        full_address = full_address + ', ' + postal_code
                    }

                    if (this.realestate.municipality) {
                        municipality = this.realestate.municipality.name_ine
                        full_address = full_address + ', ' + municipality
                    }

                    this.SET_REALESTATE_FULL_ADDRESS(full_address)

                    this.SET_REALESTATE_STREET_NAME(street_name)

                    if (!e.target.value || e.target.value.length === 0) {
                        // console.log('no street name')

                        this.SET_REALESTATE_LAT(null)
                        this.realestate.lat = null

                        this.SET_REALESTATE_LNG(null)
                        this.realestate.lng = null

                        this.SET_REALESTATE_EPSG25831_X(null)
                        this.realestate.epsg25831_x = null

                        this.SET_REALESTATE_EPSG25831_Y(null)
                        this.realestate.epsg25831_y = null

                        this.SET_REALESTATE_CADASTRAL_REFERENCE(null)
                        this.realestate.cadastral_reference = null

                        this.SET_REALESTATE_CENSUS_SECTION_CODE(null)
                        this.realestate.census_section_code = null

                        this.SET_REALESTATE_POSTAL_CODE(null)
                        this.realestate.postal_code = null

                        this.SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS(null)
                        this.realestate.google_formatted_address = null

                    }
                }, 1000),
            set_realestate_street_number:
                _.debounce(function (e) {
                    this.SET_REALESTATE_STREET_NUMBER(e.target.value)

                    let street_name = ''
                    let street_number = e.target.value
                    let floor = ''
                    let door = ''
                    let staircase = ''
                    let block = ''
                    let postal_code = ''
                    let municipality = ''
                    let full_address = ''

                    if (this.realestate.street_name) {
                        street_name = this.realestate.street_name
                        full_address = street_name
                    }

                    full_address = full_address + ', ' + street_number

                    if (this.realestate.floor) {
                        floor = this.realestate.floor
                        full_address = full_address + ', ' + floor
                    }

                    if (this.realestate.door) {
                        door = this.realestate.door
                        if (this.realestate.floor) {
                            full_address = full_address + ' ' + door
                        } else {
                            full_address = full_address + Vue.i18n.translate('door') + ' ' + door
                        }

                    }

                    if (this.realestate.staircase) {
                        staircase = this.realestate.staircase
                        full_address = full_address + ', ' + Vue.i18n.translate('staircase') + ' ' + staircase
                    }

                    if (this.realestate.block) {
                        block = this.realestate.block
                        full_address = full_address + ', ' + Vue.i18n.translate('block') + ' ' + block
                    }

                    if (this.realestate.postal_code) {
                        postal_code = this.realestate.postal_code
                        full_address = full_address + ', ' + postal_code
                    }

                    if (this.realestate.municipality) {
                        municipality = this.realestate.municipality.name_ine
                        full_address = full_address + ', ' + municipality
                    }

                    this.SET_REALESTATE_FULL_ADDRESS(full_address)

                }, 1000),
            set_realestate_area_average_price_coef: _.debounce(function (e) {

                let coef = 0.95
                let area_average_price = this.realestate.area_average_price

                if (!area_average_price || isNaN(area_average_price) === true) {
                    area_average_price = 0
                }

                if (e) {
                    coef = Number(e.target.value)
                }

                let adopted_area_average_price = this.roundToTwo(area_average_price * coef)

                let area = 0

                if (this.realestate.estimated_built_area) {
                    area = this.realestate.estimated_built_area
                }

                let pre_appraisal_value = this.roundToTwo(adopted_area_average_price * area)

                this.SET_REALESTATE_ESTIMATED_BUILT_AREA(area)
                this.SET_REALESTATE_PRE_APPRAISAL_VALUE(pre_appraisal_value)
                this.SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE(adopted_area_average_price)
                this.SET_REALESTATE_AREA_AVERAGE_PRICE_COEF(coef)

                this.set_base_fees(pre_appraisal_value)

            }, 0),
            set_realestate_quote_price_incl_travel_expenses: _.debounce(function (e) {
                this.SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES(Number(e.target.value))
            }, 1000),
            set_base_fees: _.debounce(function (pre_appraisal_value) {

                let base_fees = 0
                let bp_coef = 1
                if (this.realestate.quote_base_price_coef) {
                    bp_coef = this.realestate.quote_base_price_coef
                }
                let quote_excess_pct = 0
                let excess = 0
                let base_price = 0

                let is_eco = this.realestate.quote_appraisal_type_is_eco

                let roundToTwoTemp = function (num) {
                    return +(Math.round(num + 'e+2') + 'e-2')
                }

                if (this.realestate.property_type.name_db === 'residential' || this.realestate.property_type.name_db === 'parking' || this.realestate.property_type.name_db === 'storage') {
                    _.forEach(this.valuation_prices.group_A, function (range, key) {
                        // console.log('pre_appraisal_value: ')
                        // console.log(pre_appraisal_value)
                        // console.log('range.ceil: ')
                        // console.log(range.ceil)
                        // console.log('range.floor: ')
                        // console.log(range.floor)

                        if (pre_appraisal_value >= range.floor && pre_appraisal_value < range.ceil) {

                            excess = pre_appraisal_value - range.floor

                            if (is_eco) {

                                base_fees = range.mortgage_valuation_fee
                                // console.log('base_fees: ')
                                // console.log(base_fees)

                                quote_excess_pct = range.increment_pct_mortgage_valuation
                                base_price = roundToTwoTemp((base_fees + (excess * (quote_excess_pct / 100))) * bp_coef)

                            } else {
                                base_fees = range.standard_valuation_fee
                                // console.log('base_fees: ')
                                // console.log(base_fees)

                                quote_excess_pct = range.increment_pct_standard_valuation
                                base_price = roundToTwoTemp((base_fees + (excess * (quote_excess_pct / 100))) * bp_coef)
                            }

                        }
                    })
                } else if (this.realestate.property_type.name_db === 'retail_and_industrial' || this.realestate.property_type.name_db === 'office') {
                    _.forEach(this.valuation_prices.group_B, function (range, key) {
                        // console.log('pre_appraisal_value: ')
                        // console.log(pre_appraisal_value)
                        // console.log('range.ceil: ')
                        // console.log(range.ceil)
                        // console.log('range.floor: ')
                        // console.log(range.floor)

                        if (pre_appraisal_value >= range.floor && pre_appraisal_value < range.ceil) {

                            excess = pre_appraisal_value - range.floor

                            console.log('excess: ')
                            console.log(excess)

                            if (is_eco) {

                                base_fees = range.mortgage_valuation_fee

                                quote_excess_pct = range.increment_pct_mortgage_valuation
                                base_price = roundToTwoTemp((base_fees + (excess * (quote_excess_pct / 100))) * bp_coef)

                                console.log('base_fees: ')
                                console.log(base_fees)

                                console.log('quote_excess_pct: ')
                                console.log(quote_excess_pct)

                                console.log('base_price: ')
                                console.log(base_price)

                            } else {
                                base_fees = range.standard_valuation_fee
                                // console.log('base_fees: ')
                                // console.log(base_fees)

                                quote_excess_pct = range.increment_pct_standard_valuation
                                base_price = roundToTwoTemp((base_fees + (excess * (quote_excess_pct / 100))) * bp_coef)
                            }

                        }
                    })
                }
                else {
                    _.forEach(this.valuation_prices.group_C, function (range, key) {
                        // console.log('pre_appraisal_value: ')
                        // console.log(pre_appraisal_value)
                        // console.log('range.ceil: ')
                        // console.log(range.ceil)
                        // console.log('range.floor: ')
                        // console.log(range.floor)

                        if (pre_appraisal_value >= range.floor && pre_appraisal_value < range.ceil) {

                            excess = pre_appraisal_value - range.floor

                            base_fees = range.standard_valuation_fee
                            // console.log('base_fees: ')
                            // console.log(base_fees)

                            quote_excess_pct = range.increment_pct_standard_valuation
                            base_price = roundToTwoTemp((base_fees + (excess * (quote_excess_pct / 100))) * bp_coef)

                        }
                    })

                }
                /*
				else if(this.realestate.property_type.name_db === 'entire_buildings' || this.realestate.property_type.name_db === 'land'){

				}
				*/

                this.SET_REALESTATE_QUOTE_BASE_FEES(base_fees)
                this.SET_REALESTATE_QUOTE_EXCESS(excess)
                this.SET_REALESTATE_QUOTE_EXCESS_PCT(quote_excess_pct)
                this.SET_REALESTATE_QUOTE_BASE_PRICE(base_price)
                this.SET_REALESTATE_QUOTE_BASE_PRICE_COEF(bp_coef)

                this.SET_REALESTATE_QUOTE_BASE_FEES(base_fees)

                let total_travel_fees = this.realestate.total_travel_fees
                this.calc_base_price(base_fees, quote_excess_pct, bp_coef, total_travel_fees, excess)

            }, 0),
            set_realestate_adopted_area_average_price: _.debounce(function (e) {
                this.SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE(Number(e.target.value))
            }, 1000),
            set_realestate_estimated_built_area: _.debounce(function (e) {

                let area = Number(e.target.value)

                let adopted_area_average_price = 0

                if (this.realestate.adopted_area_average_price) {
                    adopted_area_average_price = this.realestate.adopted_area_average_price
                }

                let pre_appraisal_value = this.roundToTwo(adopted_area_average_price * area)

                this.SET_REALESTATE_PRE_APPRAISAL_VALUE(pre_appraisal_value)

                this.SET_REALESTATE_ESTIMATED_BUILT_AREA(area)

                this.set_base_fees(pre_appraisal_value)

            }, 0),
            set_realestate_pre_appraisal_value: _.debounce(function (e) {
                this.SET_REALESTATE_PRE_APPRAISAL_VALUE(Number(e.target.value))
            }, 1000),
            set_realestate_travel_one_way_hours: _.debounce(function (e) {

                let hours = Number(e.target.value)
                this.SET_REALESTATE_TRAVEL_ONE_WAY_HOURS(hours)

                if (hours > 0) {
                    this.SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS(hours * 2)
                } else if (hours === 0 || !hours) {
                    this.SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS(0)

                }
                this.set_realestate_total_travel_fees()

            }, 0),
            set_realestate_travel_both_ways_hours: _.debounce(function (e) {
                this.SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS(Number(e.target.value))
            }, 0),
            set_realestate_travel_fees_per_hour: _.debounce(function (e) {
                this.SET_REALESTATE_TRAVEL_FEES_PER_HOUR(Number(e.target.value))
                this.set_realestate_total_travel_fees()
            }, 0),
            set_realestate_car_fuel_expenses_one_way: _.debounce(function (e) {

                let fuel_expenses = Number(e.target.value)

                this.SET_REALESTATE_CAR_FUEL_EXPENSES_ONE_WAY(fuel_expenses)
                this.SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS(this.roundToTwo(fuel_expenses * 2))
                this.set_realestate_total_travel_fees()
            }, 0),
            set_realestate_car_fuel_expenses_both_ways: _.debounce(function (e) {
                this.SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS(Number(e.target.value))
            }, 0),
            set_realestate_car_toll_expenses_one_way: _.debounce(function (e) {
                let toll_expenses = Number(e.target.value)

                this.SET_REALESTATE_CAR_TOLL_EXPENSES_ONE_WAY(toll_expenses)
                this.SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS(this.roundToTwo(toll_expenses * 2))
                this.set_realestate_total_travel_fees()
            }, 0),
            set_realestate_car_toll_expenses_both_ways: _.debounce(function (e) {
                this.SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS(Number(e.target.value))
            }, 0),
            set_realestate_car_expenses_one_way: _.debounce(function (e) {
                let travel_expenses = this.realestate.car_fuel_expenses_one_way + this.realestate.car_toll_expenses_one_way
                this.SET_REALESTATE_CAR_EXPENSES_ONE_WAY(travel_expenses)
            }, 0),
            set_realestate_car_expenses_both_ways: _.debounce(function (e) {
                let travel_expenses = this.realestate.car_fuel_expenses_both_ways + this.realestate.car_toll_expenses_both_ways
                this.SET_REALESTATE_CAR_EXPENSES_BOTH_WAYS(travel_expenses)
            }, 0),
            set_realestate_total_travel_fees: _.debounce(function (e) {

                let travel_expenses = this.realestate.car_fuel_expenses_both_ways + this.realestate.car_toll_expenses_both_ways

                let hours = this.realestate.travel_both_ways_hours

                if (!this.realestate.travel_both_ways_hours) {
                    hours = 0
                }

                let hourly_fees = this.realestate.travel_fees_per_hour

                if (!this.realestate.travel_fees_per_hour) {
                    hourly_fees = 0
                }
                let travel_fees = hours * hourly_fees
                let total_travel_fees = travel_expenses + travel_fees

                this.SET_REALESTATE_TOTAL_TRAVEL_FEES(total_travel_fees)

                let base_fees = this.realestate.quote_base_fees
                let quote_excess_pct = this.realestate.quote_excess_pct
                let quote_base_price_coef = this.realestate.quote_base_price_coef

                let excess = this.realestate.quote_excess

                this.calc_base_price(base_fees, quote_excess_pct, quote_base_price_coef, total_travel_fees, excess)

            }, 0),
            set_realestate_quote_base_fees: _.debounce(function (e) {

                let base_fees = Number(e.target.value)
                this.SET_REALESTATE_QUOTE_BASE_FEES(base_fees)

                let quote_excess_pct = this.realestate.quote_excess_pct
                let quote_base_price_coef = this.realestate.quote_base_price_coef

                let total_travel_fees = this.realestate.total_travel_fees

                let excess = this.realestate.quote_excess

                this.calc_base_price(base_fees, quote_excess_pct, quote_base_price_coef, total_travel_fees, excess)

            }, 0),
            set_realestate_quote_excess_pct: _.debounce(function (e) {

                let quote_excess_pct = Number(e.target.value)
                this.SET_REALESTATE_QUOTE_EXCESS_PCT(quote_excess_pct)

                let base_fees = this.realestate.quote_base_fees
                let quote_base_price_coef = this.realestate.quote_base_price_coef
                let total_travel_fees = this.realestate.total_travel_fees

                let excess = this.realestate.quote_excess

                this.calc_base_price(base_fees, quote_excess_pct, quote_base_price_coef, total_travel_fees, excess)
            }, 0),
            set_realestate_quote_excess: _.debounce(function (e) {
                this.SET_REALESTATE_QUOTE_EXCESS(Number(e.target.value))
            }, 0),
            set_realestate_quote_base_price: _.debounce(function (e) {

                let quote_base_price = Number(e.target.value)
                this.SET_REALESTATE_QUOTE_BASE_PRICE(quote_base_price)

                let quote_excess_pct = this.realestate.quote_excess_pct
                let quote_base_price_coef = this.realestate.quote_base_price_coef
                let total_travel_fees = this.realestate.total_travel_fees

                let excess = this.realestate.quote_excess

                this.calc_base_price(base_fees, quote_excess_pct, quote_base_price_coef, total_travel_fees, excess)
            }, 0),
            set_realestate_quote_base_price_coef: _.debounce(function (e) {

                let quote_base_price_coef = Number(e.target.value)
                this.SET_REALESTATE_QUOTE_BASE_PRICE_COEF(quote_base_price_coef)

                let base_fees = this.realestate.quote_base_fees
                let quote_excess_pct = this.realestate.quote_excess_pct
                let total_travel_fees = this.realestate.total_travel_fees

                let excess = this.realestate.quote_excess

                this.calc_base_price(base_fees, quote_excess_pct, quote_base_price_coef, total_travel_fees, excess)
            }, 0),
            set_realestate_quote_appraisal_type_is_eco: _.debounce(function (e) {
                this.set_base_fees(this.realestate.pre_appraisal_value)
                // console.log(e)
            }, 0),
            set_realestate_area_ads_query_startdate: _.debounce(function (e) {
                this.SET_REALESTATE_AREA_ADS_QUERY_STARTDATE(e.target.value)
            }, 0),
            set_realestate_area_ads_query_limitdate: _.debounce(function (e) {
                this.SET_REALESTATE_AREA_ADS_QUERY_LIMITDATE(e.target.value)
            }, 0),
            set_realestate_area_ads_query_distance: _.debounce(function (e) {
                this.SET_REALESTATE_AREA_ADS_QUERY_DISTANCE(Number(e.target.value))
            }, 1000),
            set_realestate_area_average_price: _.debounce(function (e) {

                let area_average_price = 0

                if (e) {
                    area_average_price = Number(e.target.value)
                }

                if (!area_average_price || isNaN(area_average_price) === true) {
                    area_average_price = 0
                }

                let coef = this.realestate.area_average_price_coef

                if (!coef || isNaN(coef) === true) {
                    coef = 0.95
                }

                let adopted_area_average_price = this.roundToTwo(area_average_price * coef)

                let area = 0

                if (this.realestate.estimated_built_area) {
                    area = this.realestate.estimated_built_area
                }

                let pre_appraisal_value = this.roundToTwo(adopted_area_average_price * area)

                this.SET_REALESTATE_AREA_AVERAGE_PRICE(area_average_price)

                this.SET_REALESTATE_ESTIMATED_BUILT_AREA(area)
                this.SET_REALESTATE_PRE_APPRAISAL_VALUE(pre_appraisal_value)
                this.SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE(adopted_area_average_price)
                this.SET_REALESTATE_AREA_AVERAGE_PRICE_COEF(coef)

                this.set_base_fees(pre_appraisal_value)

            }, 1000),
            set_realestate_asset_type: _.debounce(function (e) {
                this.SET_REALESTATE_ASSET_TYPE(e)
            }, 500),
            set_realestate_dwelling_type: _.debounce(function (e) {
                this.SET_REALESTATE_DWELLING_TYPE(e)
            }, 500),
            set_realestate_floor_type: _.debounce(function(e){
                this.SET_REALESTATE_FLOOR_TYPE(e)
            }, 1000),
            calc_base_price: _.debounce(function (base_fees, quote_excess_pct, bp_coef, total_travel_fees, excess) {
                let base_price = this.roundToTwo((base_fees + (excess * (quote_excess_pct / 100))) * bp_coef)
                this.SET_REALESTATE_QUOTE_BASE_PRICE(base_price)

                let quote_price_incl_travel_expenses = base_price + total_travel_fees
                this.SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES(quote_price_incl_travel_expenses)
            }, 0),
            onSaveCurrentRealEstate:
                function (data) {
                    this.UPDATE_REALESTATE({
                        key: this.realestate.id,
                        object: this.realestate,
                        // parent_path: 'appraisalreports/' + this.appraisalreport.id + '/' + 'realestates' + '/',
                        path: this.realestate.path + this.realestate.id,
                        file_id: this.appraisalfile.id,
                        report_id: this.appraisalreport.id
                    }).then((res) => {
                        if (data.go_up) {
                            this.onGoUp()
                        } else {
                            this.setCurrentTab(this.currentTabTitle)
                            window.scroll(0, 0)
                        }
                    })
                }

            ,

            onGoBack: function () {
                // console.log('yeah back')
                router.go(-1)
            }
            ,
            onGoUp: function () {
                // console.log('yeah back')
                this.$router.push({name: 'appraisalreport-editor', query: {id: this.appraisalreport.id}})
            }
            ,
            onCancelAll: function () {
                const result = window.confirm(Vue.i18n.translate('Changes_will_be_lost_p_continue_q'))

                if (result) {
                    router.go(-1)
                } else {
                    return false

                }

            },
            openAdUrl: function (url) {
                if (url) {
                    const win = window.open(url, '_blank')
                    win.focus()
                }
            },
            discardAd: function (index) {

                console.log('index: ')
                console.log(index)

                let markers = this.realestate.area_ads_markers

                // delete the element from array
                markers.splice(index, 1)

                let unit_prices = _.map(markers, 'unit_price')

                let max = Math.max.apply(null, unit_prices)
                let min = Math.min.apply(null, unit_prices)
                let diff = max - min

                _.forEach(markers, function (value, index) {

                    let label = {
                        color: 'black',
                        text: (index + 1).toString()
                    }
                    markers[index]['label'] = label

                    // calculating step for color scale formatting
                    let step = (unit_prices[index] - min ) / diff
                    markers[index]['step'] = step

                })

                console.log('markers: ')
                console.log(markers)

                let area_average_price = this.calcMean(unit_prices)

                console.log('area_average_price: ')
                console.log(area_average_price)

                this.realestate.area_ads_markers = markers
                this.SET_REALESTATE_AREA_ADS_MARKERS(markers)
                this.SET_REALESTATE_AREA_AVERAGE_PRICE(area_average_price)

                let coef = 0.95

                if (this.realestate.area_average_price_coef) {
                    coef = this.realestate.area_average_price_coef
                }

                let adopted_area_average_price = this.roundToTwo(area_average_price * coef)

                console.log('adopted_area_average_price: ')
                console.log(adopted_area_average_price)

                this.SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE(adopted_area_average_price)

                let area = 0

                if (this.realestate.estimated_built_area) {
                    area = this.realestate.estimated_built_area
                }

                let pre_appraisal_value = this.roundToTwo(adopted_area_average_price * area)

                this.SET_REALESTATE_PRE_APPRAISAL_VALUE(pre_appraisal_value)

                this.set_base_fees(pre_appraisal_value)

                this.$forceUpdate()
            },
            onGeolocate: function () {
                this.google_geocode_loading = true
                this.master_loading = true

                this.GEOLOCATE_REALESTATE({
                    id: this.realestate.id,
                    old_geohash: this.realestate.geohash,
                    street_name: this.realestate.street_name,
                    street_number: this.realestate.street_number,
                    municipality: this.realestate.municipality
                }).then((res) => {

                    if (res.none) {

                        this.google_geocode_loading = false
                        this.master_loading = false

                    } else {
                        let lat = null
                        let lng = null

                        console.log('res.lat?: ')
                        console.log(res.lat)

                        if (res.lat) {
                            lat = res.lat
                        }

                        if (res.lng) {
                            lng = res.lng
                        }
                        this.SET_REALESTATE_MAP_GOOGLE_01_LAT(lat)
                        this.SET_REALESTATE_MAP_GOOGLE_01_LNG(lng)
                        this.SET_REALESTATE_MAP_GOOGLE_01_ZOOM('13')

                        this.SET_REALESTATE_MAP_GOOGLE_02_LAT(lat)
                        this.SET_REALESTATE_MAP_GOOGLE_02_LNG(lng)
                        this.SET_REALESTATE_MAP_GOOGLE_02_ZOOM('16')

                        this.SET_REALESTATE_MAP_GOOGLE_03_LAT(lat)
                        this.SET_REALESTATE_MAP_GOOGLE_03_LNG(lng)
                        this.SET_REALESTATE_MAP_GOOGLE_03_ZOOM('19')

                        this.setMapGoogle01(lat, lng, '13', this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
                        this.setMapGoogle02(lat, lng, '16', this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
                        this.setMapGoogle03(lat, lng, '19', this.google_map_size, 'hybrid', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')

                        // console.log('GELOCATE RES: ')
                        // console.log(res)

                        this.google_geocode_loading = false
                        this.master_loading = false
                    }

                })
            },
            onCheckPrices: function () {

                this.check_prices_loading = true
                this.master_loading = true

                this.onSaveCurrentRealEstate({go_up: false})

                console.log('this.prices_startdate: ')
                console.log(this.prices_startdate)

                console.log('this.prices_limitdate: ')
                console.log(this.prices_limitdate)

                this.QUERY_ADS({
                    key: this.realestate.id,
                    lat: this.realestate.lat,
                    lng: this.realestate.lng,
                    ad_type: this.realestate.property_type ? this.realestate.property_type.name_db : 'residential',
                    startdate: this.prices_startdate,
                    limitdate: this.prices_limitdate,
                    geohash: this.realestate.geohash,
                    radius_km: this.realestate.area_ads_query_distance ? this.realestate.area_ads_query_distance : 1
                }).then((res2) => {

                    let area_average_price = 0

                    if (res2.area_average_price && isNaN(res2.area_average_price) === false) {
                        area_average_price = res2.area_average_price
                    } else {
                        area_average_price = 0
                    }

                    let coef = 0.95

                    if (this.realestate.area_average_price_coef) {
                        coef = this.realestate.area_average_price_coef
                    }

                    let adopted_area_average_price = this.roundToTwo(area_average_price * coef)

                    // console.log('average price in the area: ')
                    // console.log(area_average_price)

                    let area = 0

                    if (this.realestate.estimated_built_area) {
                        area = this.realestate.estimated_built_area
                    }

                    let pre_appraisal_value = this.roundToTwo(adopted_area_average_price * area)

                    this.SET_REALESTATE_ESTIMATED_BUILT_AREA(area)
                    this.SET_REALESTATE_PRE_APPRAISAL_VALUE(pre_appraisal_value)

                    this.set_base_fees(pre_appraisal_value)

                    this.realestate.area_average_price = area_average_price
                    this.realestate.adopted_area_average_price = adopted_area_average_price
                    this.realestate.area_ads_markers = res2.markers

                    this.SET_REALESTATE_AREA_ADS_MARKERS(res2.markers)
                    this.SET_REALESTATE_AREA_AVERAGE_PRICE_COEF(coef)
                    this.SET_REALESTATE_AREA_AVERAGE_PRICE(area_average_price)
                    this.SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE(adopted_area_average_price)

                    this.$forceUpdate()

                    this.check_prices_loading = false
                    this.master_loading = false

                })

            },
            setMapGoogle01 (lat, lng, zoom, size, maptype, style, key) {
                // console.log('setting Map Google 01....')

                if (!zoom) {
                    zoom = '13'
                }

                if (!lat) {
                    lat = this.realestate.lat
                }

                if (!lng) {
                    lng = this.realestate.lng
                }

                let map_01_url = 'https://maps.googleapis.com/maps/api/staticmap?' +
                    'center=' + lat + ',' + lng +
                    '&zoom=' + zoom +
                    '&size=' + size +
                    '&maptype=' + maptype +
                    '&markers=color:red%7Clabel:T%7C' + lat + ',' + lng +
                    '&style=' + style +
                    '&format=' + 'png' +
                    '&visual_refresh=' + 'true' +
                    '&key=' + key

                this.realestate.map_google_01_url = map_01_url
                this.SET_REALESTATE_MAP_GOOGLE_01_URL(map_01_url)
            }
            ,
            setMapGoogle02 (lat, lng, zoom, size, maptype, style, key) {
                // console.log('setting Map Google 02....')

                if (!zoom) {
                    zoom = '16'
                }

                if (!lat) {
                    lat = this.realestate.lat
                }

                if (!lng) {
                    lng = this.realestate.lng
                }

                let map_02_url = 'https://maps.googleapis.com/maps/api/staticmap?' +
                    'center=' + lat + ',' + lng +
                    '&zoom=' + zoom +
                    '&size=' + size +
                    '&maptype=' + maptype +
                    '&markers=color:red%7Clabel:T%7C' + lat + ',' + lng +
                    '&style=' + style +
                    '&format=' + 'png' +
                    '&visual_refresh=' + 'true' +
                    '&key=' + key

                this.realestate.map_google_02_url = map_02_url
                this.SET_REALESTATE_MAP_GOOGLE_02_URL(map_02_url)
            }
            ,
            setMapGoogle03 (lat, lng, zoom, size, maptype, style, key) {
                // console.log('setting Map Google 03....')

                if (!zoom) {
                    zoom = '19'
                }

                if (!lat) {
                    lat = this.realestate.lat
                }

                if (!lng) {
                    lng = this.realestate.lng
                }

                let map_03_url = 'https://maps.googleapis.com/maps/api/staticmap?' +
                    'center=' + lat + ',' + lng +
                    '&zoom=' + zoom +
                    '&size=' + size +
                    '&maptype=' + maptype +
                    '&markers=color:red%7Clabel:T%7C' + lat + ',' + lng +
                    '&style=' + style +
                    '&format=' + 'png' +
                    '&visual_refresh=' + 'true' +
                    '&key=' + key

                this.realestate.map_google_03_url = map_03_url
                this.SET_REALESTATE_MAP_GOOGLE_03_URL(map_03_url)
            }
            ,
            onRefreshMaps: function () {
                // console.log('refreshing Maps...')
                let zoom = '13'
                if (this.realestate.map_google_01_zoom) {
                    zoom = this.realestate.map_google_01_zoom.toString()
                }
                this.setMapGoogle01(this.realestate.lat, this.realestate.lng, zoom, '640x640', 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onDecreaseZoomMapGoogle01: function () {
                // console.log('decreasing Maps Zoom...')

                let map_google_01_zoom = (Number(this.realestate.map_google_01_zoom) - 1).toString()
                this.SET_REALESTATE_MAP_GOOGLE_01_ZOOM(map_google_01_zoom)

                this.setMapGoogle01(this.realestate.map_google_01_lat, this.realestate.map_google_01_lng, map_google_01_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onIncreaseZoomMapGoogle01: function () {
                // console.log('increasing Maps Zoom...')

                let map_google_01_zoom = (Number(this.realestate.map_google_01_zoom) + 1).toString()
                this.SET_REALESTATE_MAP_GOOGLE_01_ZOOM(map_google_01_zoom)

                this.setMapGoogle01(this.realestate.map_google_01_lat, this.realestate.map_google_01_lng, map_google_01_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onGoUpMapGoogle01: function () {
                // console.log('going up Maps Zoom...')

                let map_google_01_lat = this.realestate.map_google_01_lat + this.google_map_offset
                this.SET_REALESTATE_MAP_GOOGLE_01_LAT(map_google_01_lat)

                this.setMapGoogle01(map_google_01_lat, this.realestate.map_google_01_lng, this.realestate.map_google_01_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onGoLeftMapGoogle01: function () {
                // console.log('going left Maps Zoom...')

                let map_google_01_lng = this.realestate.map_google_01_lng - this.google_map_offset
                this.SET_REALESTATE_MAP_GOOGLE_01_LNG(map_google_01_lng)

                this.setMapGoogle01(this.realestate.map_google_01_lat, map_google_01_lng, this.realestate.map_google_01_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onGoRightMapGoogle01: function () {
                // console.log('going right Maps Zoom...')

                let map_google_01_lng = this.realestate.map_google_01_lng + this.google_map_offset
                this.SET_REALESTATE_MAP_GOOGLE_01_LNG(map_google_01_lng)

                this.setMapGoogle01(this.realestate.map_google_01_lat, map_google_01_lng, this.realestate.map_google_01_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onGoDownMapGoogle01: function () {
                // console.log('going down Maps Zoom...')

                let map_google_01_lat = this.realestate.map_google_01_lat - this.google_map_offset
                this.SET_REALESTATE_MAP_GOOGLE_01_LAT(map_google_01_lat)

                this.setMapGoogle01(map_google_01_lat, this.realestate.map_google_01_lng, this.realestate.map_google_01_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onDecreaseZoomMapGoogle02: function () {
                // console.log('decreasing Maps Zoom...')

                let map_google_02_zoom = (Number(this.realestate.map_google_02_zoom) - 1).toString()
                this.SET_REALESTATE_MAP_GOOGLE_02_ZOOM(map_google_02_zoom)

                this.setMapGoogle02(this.realestate.map_google_02_lat, this.realestate.map_google_02_lng, map_google_02_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onIncreaseZoomMapGoogle02: function () {
                // console.log('increasing Maps Zoom...')

                let map_google_02_zoom = (Number(this.realestate.map_google_02_zoom) + 1).toString()
                this.SET_REALESTATE_MAP_GOOGLE_02_ZOOM(map_google_02_zoom)

                this.setMapGoogle02(this.realestate.map_google_02_lat, this.realestate.map_google_02_lng, map_google_02_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onGoUpMapGoogle02: function () {
                // console.log('going up Maps Zoom...')

                let map_google_02_lat = this.realestate.map_google_02_lat + this.google_map_offset
                this.SET_REALESTATE_MAP_GOOGLE_02_LAT(map_google_02_lat)

                this.setMapGoogle02(map_google_02_lat, this.realestate.map_google_02_lng, this.realestate.map_google_02_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onGoLeftMapGoogle02: function () {
                // console.log('going left Maps Zoom...')

                let map_google_02_lng = this.realestate.map_google_02_lng - this.google_map_offset
                this.SET_REALESTATE_MAP_GOOGLE_02_LNG(map_google_02_lng)

                this.setMapGoogle02(this.realestate.map_google_02_lat, map_google_02_lng, this.realestate.map_google_02_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onGoRightMapGoogle02: function () {
                // console.log('going right Maps Zoom...')

                let map_google_02_lng = this.realestate.map_google_02_lng + this.google_map_offset
                this.SET_REALESTATE_MAP_GOOGLE_02_LNG(map_google_02_lng)

                this.setMapGoogle02(this.realestate.map_google_02_lat, map_google_02_lng, this.realestate.map_google_02_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onGoDownMapGoogle02: function () {
                // console.log('going down Maps Zoom...')

                let map_google_02_lat = this.realestate.map_google_02_lat - this.google_map_offset
                this.SET_REALESTATE_MAP_GOOGLE_02_LAT(map_google_02_lat)

                this.setMapGoogle02(map_google_02_lat, this.realestate.map_google_02_lng, this.realestate.map_google_02_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onDecreaseZoomMapGoogle03: function () {
                // console.log('decreasing Maps Zoom...')

                let map_google_03_zoom = (Number(this.realestate.map_google_03_zoom) - 1).toString()
                this.SET_REALESTATE_MAP_GOOGLE_03_ZOOM(map_google_03_zoom)

                this.setMapGoogle03(this.realestate.map_google_03_lat, this.realestate.map_google_03_lng, map_google_03_zoom, this.google_map_size, 'hybrid', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onIncreaseZoomMapGoogle03: function () {
                // console.log('increasing Maps Zoom...')

                let map_google_03_zoom = (Number(this.realestate.map_google_03_zoom) + 1).toString()
                this.SET_REALESTATE_MAP_GOOGLE_03_ZOOM(map_google_03_zoom)

                this.setMapGoogle03(this.realestate.map_google_03_lat, this.realestate.map_google_03_lng, map_google_03_zoom, this.google_map_size, 'hybrid', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onGoUpMapGoogle03: function () {
                // console.log('going up Maps Zoom...')

                let map_google_03_lat = this.realestate.map_google_03_lat + this.google_map_offset
                this.SET_REALESTATE_MAP_GOOGLE_03_LAT(map_google_03_lat)

                this.setMapGoogle03(map_google_03_lat, this.realestate.map_google_03_lng, this.realestate.map_google_03_zoom, this.google_map_size, 'hybrid', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onGoLeftMapGoogle03: function () {
                // console.log('going left Maps Zoom...')

                let map_google_03_lng = this.realestate.map_google_03_lng - this.google_map_offset
                this.SET_REALESTATE_MAP_GOOGLE_03_LNG(map_google_03_lng)

                this.setMapGoogle03(this.realestate.map_google_03_lat, map_google_03_lng, this.realestate.map_google_03_zoom, this.google_map_size, 'hybrid', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onGoRightMapGoogle03: function () {
                // console.log('going right Maps Zoom...')

                let map_google_03_lng = this.realestate.map_google_03_lng + this.google_map_offset
                this.SET_REALESTATE_MAP_GOOGLE_03_LNG(map_google_03_lng)

                this.setMapGoogle03(this.realestate.map_google_03_lat, map_google_03_lng, this.realestate.map_google_03_zoom, this.google_map_size, 'hybrid', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onGoDownMapGoogle03: function () {
                // console.log('going down Maps Zoom...')

                let map_google_03_lat = this.realestate.map_google_03_lat - this.google_map_offset
                this.SET_REALESTATE_MAP_GOOGLE_03_LAT(map_google_03_lat)

                this.setMapGoogle03(map_google_03_lat, this.realestate.map_google_03_lng, this.realestate.map_google_03_zoom, this.google_map_size, 'hybrid', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k')
            }
            ,
            onRequestCensusSectionInfo: function () {
                console.log('requesting census section info...')
                this.icc_census_section_loading = true
                this.REQUEST_CENSUS_SECTION_INFO({
                    x: this.realestate.epsg25831_x,
                    y: this.realestate.epsg25831_y
                }).then((res) => {
                    //
                    this.icc_census_section_loading = false
                })
            }
            ,
            onRequestCadastralReferenceSuggestion: function () {
                console.log('requesting cadastral reference suggestion...')
                this.cadaster_ref_loading = true
                this.REQUEST_CADASTRAL_REFERENCE_BY_COORDINATES({
                    x: this.realestate.epsg25831_x,
                    y: this.realestate.epsg25831_y
                }).then((res) => {
                    //
                    this.cadaster_ref_loading = false
                })
            }
            ,
            onOpenCadastralList: function () {
                console.log('opening cadastral list...')
                // const url = 'https://www.whatismyreferer.com/'
                const refcat = this.realestate.cadastral_reference
                const rc1 = refcat.substring(0, 7)
                const rc2 = refcat.substring(7, 14)
                const url = 'https://www1.sedecatastro.gob.es/CYCBienInmueble/OVCListaBienes.aspx?del=' + this.realestate.municipality.cadaster_province_code + '&muni=' + this.realestate.municipality.cadaster_municipality_code + '&rc1=' + rc1 + '&rc2=' + rc2
                const win = window.open(url, '_blank')
                win.focus()
            }
            ,
            onOpenCadastralMap: function () {
                console.log('opening cadastral map...')

                const url = 'https://www1.sedecatastro.gob.es/Cartografia/mapa.aspx?del=' + this.realestate.municipality.cadaster_province_code + '&mun=' + this.realestate.municipality.cadaster_municipality_code + '&refcat=' + this.realestate.cadastral_reference + '&final='
                const win = window.open(url, '_blank')
                win.focus()

            }
            ,
            onRequestGoogleMap: function () {

            }
            ,
            onCreateNewAppraisal: function () {

                this.master_loading = true
                this.RESET_APPRAISAL().then((res) => {
                    this.CREATE_NEW_APPRAISAL({
                        path: 'realestate_appraisals' + '/' + this.realestate.id + '/',
                        parent_path: 'realestates' + '/' + this.realestate.id + '/' + 'appraisals' + '/',
                        file_id: this.appraisalfile.id,
                        realestate_id: this.realestate.id
                    }).then((res) => {
                        this.$router.push({name: 'appraisal-editor', query: {id: this.appraisal.id}})
                    })
                })

            },
            onCreateNewProject: function () {

                this.master_loading = true
                this.RESET_PROJECT().then((res) => {
                    this.CREATE_NEW_PROJECT({
                        path: 'realestate_projects' + '/' + this.realestate.id + '/',
                        parent_path: 'realestates' + '/' + this.realestate.id + '/' + 'projects' + '/',
                        // file_id: this.projectfile.id,
                        realestate_id: this.realestate.id
                    }).then((res) => {
                        this.$router.push({name: 'project-editor', query: {id: this.project.id}})
                    })
                })

            },
            onCreateNewMarketStudy: function () {
                let appraisal_id = this.object_to_array(this.realestate_appraisals)[0].id
                // console.log('appraisal_id: )
                // console.log(appraisal_id)
                this.master_loading = true
                this.RESET_MARKETSTUDY().then((res) => {
                    this.CREATE_NEW_MARKETSTUDY({
                        path: 'realestate_marketstudies' + '/' + this.realestate.id + '/',
                        parent_path: 'realestates' + '/' + this.realestate.id + '/' + 'marketstudies' + '/',
                        file_id: this.appraisalfile.id,
                        appraisal_id: appraisal_id,
                        realestate_id: this.realestate.id
                        // appraisal_id: this.object_to_array(this.realestate_appraisals).length > 0 ? this.object_to_array(this.realestate_appraisals)[0].id : null,
                    }).then((res) => {
                        this.$router.push({
                            name: 'marketstudy-editor',
                            query: {id: res.key, appraisal_id: appraisal_id}
                        })
                    })
                })

                // TODO: revisar al crear nou marketstudy.....sembla que dona algun error d'algiun element que es null a appraisal.js

            }
            ,
            duplicateAppraisal: function (entity) {
                /*
				 this.master_loading = true

				 const new_versionnumber = entity.version + 1

				 this.RESET_APPRAISALREPORT().then((res) => {
				 this.CREATE_NEW_APPRAISALREPORT({
				 path: 'appraisalreports' + '/',
				 parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
				 file_id: this.appraisalfile.id,
				 number: entity.number,
				 version: new_versionnumber
				 }).then((res) => {

				 console.log('duplicateAppraisalReport then res:')
				 console.log(res)

				 const new_object_id = res.key
				 const new_object_version = new_versionnumber

				 this.GET_APPRAISALREPORT({ path: 'appraisalreports' + '/' + entity.id }).then((res) => {

				 console.log(' *^*^*^*^*^*^*^*^*^*^get appraisal report res: ')
				 console.log(res)

				 let new_object = res
				 new_object.id = new_object_id
				 new_object.version = new_object_version


				 this.UPDATE_APPRAISALREPORT({
				 object: new_object,
				 path: 'appraisalreports/',
				 parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
				 key: new_object_id
				 }).then((res) => {

				 this.master_loading = true
				 this.FETCH_APPRAISALFILE_APPRAISALREPORTS({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalreports'})
				 .then(() => {
				 this.master_loading = false
				 })

				 })

				 })


				 })
				 })
				 */

            }
            ,
            duplicateMarketStudy: function (entity) {

            }
            ,
            editAppraisal: function (entity) {

                this.SET_APPRAISAL({path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'appraisal-editor', query: {id: entity.id}})

                })

            }
            ,
            editMarketStudy: function (entity) {

                this.SET_MARKETSTUDY({path: 'realestate_marketstudies' + '/' + this.realestate.id + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({
                        name: 'marketstudy-editor',
                        query: {id: entity.id, appraisal_id: entity.appraisal_id}
                    })

                })

            }
            ,
            editProject: function (entity) {

                this.SET_PROJECT({path: 'realestate_projects' + '/' + this.realestate.id + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'project-editor', query: {id: entity.id}})

                })

            }
            ,
            deleteAppraisal: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete ') + entity.description + '. ' + Vue.i18n.translate('Continue_q'))

                if (result) {

                    this.DELETE_APPRAISAL({
                        realestate_id: this.realestate.id,
                        path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + entity.id,
                        key: entity.id,
                        parent_path: 'realestates' + '/' + this.realestate.id + '/' + 'appraisals' + '/' + entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_REALESTATE_APPRAISALS({path: 'realestate_appraisals' + '/' + this.realestate.id + '/'}).then(() => {
                            this.master_loading = false
                        })
                    })

                }

            }
            ,
            deleteMarketStudy: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete ') + entity.description + '. ' + Vue.i18n.translate('Continue_q'))

                if (result) {

                    this.DELETE_MARKETSTUDY({
                        realestate_id: this.realestate.id,
                        path: 'realestate_marketstudies' + '/' + this.realestate.id + '/' + entity.id,
                        key: entity.id,
                        parent_path: 'realestates' + '/' + this.realestate.id + '/' + 'marketstudies' + '/' + entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_REALESTATE_MARKETSTUDIES({path: 'realestate_marketstudies' + '/' + this.realestate.id + '/'}).then(() => {
                            this.master_loading = false
                        })
                    })

                }

            },
            deleteProject: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete ') + entity.description + '. ' + Vue.i18n.translate('Continue_q'))

                if (result) {

                    this.DELETE_PROJECT({
                        realestate_id: this.realestate.id,
                        path: 'realestate_projects' + '/' + this.realestate.id + '/' + entity.id,
                        key: entity.id,
                        parent_path: 'realestates' + '/' + this.realestate.id + '/' + 'projects' + '/' + entity.id
                    }).then((res) => {
                        //
                        this.master_loading = true
                        this.FETCH_REALESTATE_PROJECTS({path: 'realestate_projects' + '/' + this.realestate.id + '/'}).then(() => {
                            this.master_loading = false
                        })
                    })

                }

            }
        }
        ,
        head: {
            title: {
                //inner: Vue.i18n.translate('New_contact')
                inner: 'Edit realestate'
            }
        }

    }
</script>


// WEBPACK FOOTER //
// RealEstateEditor.vue?081535cc